// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Plus+Jakarta+Sans:wght@300;400;500;600;700;800&family=Lora:ital,wght@0,400;0,600;1,400&display=swap);"]);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* ======================================
   DESIGN TOKENS — Pyate Blue Brand
====================================== */
:root {
  --brand:          #1565C0;
  --brand-mid:      #1976D2;
  --brand-light:    #42A5F5;
  --brand-soft:     #E3F2FD;
  --brand-glow:     rgba(21, 101, 192, 0.18);
  --accent:         #00BCD4;
  --surface:        #ffffff;
  --surface-2:      #F8FAFC;
  --surface-3:      #EEF4FB;
  --border:         #DBEAFE;
  --border-strong:  #BFDBFE;
  --text-primary:   #0D1B2A;
  --text-secondary: #3B5270;
  --text-muted:     #7A96B2;
  --danger:         #EF4444;
  --danger-soft:    #FEF2F2;
  --like-red:       #E91E63;
  --like-soft:      #FCE4EC;
  --success:        #22C55E;
  --font:           'Plus Jakarta Sans', sans-serif;
  --font-serif:     'Lora', serif;
  --ease:           cubic-bezier(0.16, 1, 0.3, 1);
  --radius-sm:      8px;
  --radius-md:      14px;
  --radius-lg:      20px;
  --shadow-sm:      0 1px 4px rgba(21,101,192,0.07), 0 4px 14px rgba(21,101,192,0.05);
  --shadow-md:      0 4px 20px rgba(21,101,192,0.12), 0 12px 36px rgba(21,101,192,0.07);
  --shadow-lg:      0 8px 36px rgba(21,101,192,0.16), 0 28px 60px rgba(21,101,192,0.09);
}

* { box-sizing: border-box; }

/* ======================================
   FEED CONTAINER
====================================== */
.linkedin-feed {
  font-family: var(--font);
  width: 100%;
  max-width: 620px;
  margin: 80px auto 0;
  padding: 20px 16px 60px;
}

/* ======================================
   LOADING
====================================== */
.loading-container-home {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  height: 300px;
  width: 100%;
  gap: 16px;
}

.loading-spinner-home {
  border: 4px solid var(--brand-soft);
  border-top: 4px solid var(--brand);
  border-radius: 50%;
  width: 52px;
  height: 52px;
  animation: spin 0.85s linear infinite;
}

@keyframes spin {
  0%   { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
}

/* ======================================
   EMPTY / NO POSTS STATE
====================================== */
.no-posts,
.empty-posts {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 48px 24px;
  text-align: center;
  background: var(--surface);
  border: 1px solid var(--border-strong);
  border-radius: var(--radius-lg);
  box-shadow: var(--shadow-sm);
  margin: 20px auto;
  max-width: 420px;
  font-family: var(--font);
  color: var(--text-muted);
  gap: 10px;
}

.empty-posts-icon {
  font-size: 48px;
  color: var(--brand-light);
  margin-bottom: 6px;
  opacity: 0.7;
}

.empty-posts h3 {
  font-size: 16px;
  font-weight: 700;
  color: var(--text-secondary);
  margin: 0;
}

.empty-posts p {
  font-size: 13.5px;
  color: var(--text-muted);
  margin: 0;
  line-height: 1.55;
}

.update-location-btn {
  background: linear-gradient(135deg, var(--brand), var(--brand-mid));
  color: white;
  border: none;
  border-radius: 100px;
  padding: 10px 22px;
  margin-top: 8px;
  cursor: pointer;
  font-family: var(--font);
  font-size: 13.5px;
  font-weight: 700;
  box-shadow: 0 3px 12px var(--brand-glow);
  transition: all 0.2s var(--ease);
}

.update-location-btn:hover {
  transform: translateY(-2px);
  box-shadow: 0 6px 20px var(--brand-glow);
}

/* ======================================
   POST CARD
====================================== */
.linkedin-post {
  background: var(--surface);
  border: 1px solid var(--border);
  border-radius: var(--radius-lg);
  margin-bottom: 18px;
  overflow: hidden;
  box-shadow: var(--shadow-sm);
  transition: transform 0.25s var(--ease), box-shadow 0.25s var(--ease);
  position: relative;
  animation: cardIn 0.3s var(--ease) both;
}

@keyframes cardIn {
  from { opacity: 0; transform: translateY(10px); }
  to   { opacity: 1; transform: translateY(0); }
}

/* Blue gradient top stripe on hover */
.linkedin-post::before {
  content: '';
  position: absolute;
  top: 0; left: 0; right: 0;
  height: 3px;
  background: linear-gradient(90deg, var(--brand), var(--brand-light), var(--accent));
  transform: scaleX(0);
  transform-origin: left;
  transition: transform 0.3s var(--ease);
  z-index: 1;
}

.linkedin-post:hover::before { transform: scaleX(1); }
.linkedin-post:hover {
  transform: translateY(-3px);
  box-shadow: var(--shadow-md);
}

/* ======================================
   POST HEADER
====================================== */
.post-header {
  display: flex;
  align-items: center;
  padding: 16px 18px 12px;
  gap: 10px;
  border-bottom: 1px solid var(--border);
}

.post-user {
  display: flex;
  align-items: center;
  gap: 10px;
  cursor: pointer;
  padding: 4px 8px 4px 4px;
  border-radius: 100px;
  background: transparent;
  border: none;
  transition: background 0.18s;
  flex: 1 1;
  min-width: 0;
}

.post-user:hover { background: var(--surface-3); }

.post-profile-img {
  width: 44px;
  height: 44px;
  border-radius: 50%;
  object-fit: cover;
  border: 2px solid var(--brand-soft);
  box-shadow: 0 0 0 2px var(--border-strong);
  flex-shrink: 0;
}

.post-user-info {
  display: flex;
  flex-direction: column;
  min-width: 0;
}

.post-username {
  font-family: var(--font);
  font-weight: 700;
  font-size: 14.5px;
  color: var(--text-primary);
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.post-user-info span:last-child,
.post-user-info p {
  font-size: 12px;
  color: var(--text-muted);
  margin: 0;
}

/* Follow button */
.follow-btn-home {
  margin-left: auto;
  flex-shrink: 0;
  padding: 7px 18px;
  border-radius: 100px;
  background: transparent;
  color: var(--brand);
  font-family: var(--font);
  font-weight: 700;
  font-size: 13px;
  cursor: pointer;
  border: 1.5px solid var(--brand);
  transition: all 0.2s var(--ease);
  white-space: nowrap;
}

.follow-btn-home:hover {
  background: var(--brand);
  color: white;
  box-shadow: 0 3px 12px var(--brand-glow);
}

.follow-btn-home:disabled {
  opacity: 0.5;
  cursor: not-allowed;
  transform: none;
}

/* More options button */
.more-options-container {
  position: relative;
  flex-shrink: 0;
}

.more-btn {
  width: 34px;
  height: 34px;
  background: none;
  border: none;
  color: var(--text-muted);
  font-size: 18px;
  cursor: pointer;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all 0.18s;
}

.more-btn:hover {
  background: var(--surface-3);
  color: var(--brand);
}

/* Dropdown */
.dropdown-content,
.dropdown-options {
  position: absolute;
  top: 38px;
  right: 0;
  background: var(--surface);
  border: 1px solid var(--border-strong);
  border-radius: var(--radius-md);
  box-shadow: var(--shadow-md);
  z-index: 100;
  width: 185px;
  overflow: hidden;
  animation: dropIn 0.18s var(--ease);
}

@keyframes dropIn {
  from { opacity: 0; transform: translateY(-6px) scale(0.97); }
  to   { opacity: 1; transform: translateY(0) scale(1); }
}

.dropdown-item {
  display: flex;
  align-items: center;
  gap: 8px;
  width: 100%;
  padding: 10px 14px;
  background: none;
  border: none;
  font-family: var(--font);
  font-size: 13px;
  font-weight: 500;
  color: var(--text-secondary);
  cursor: pointer;
  text-align: left;
  transition: background 0.14s;
}

.dropdown-item:hover {
  background: var(--surface-3);
  color: var(--brand);
}

/* ======================================
   POST CONTENT & MEDIA
====================================== */
.post-content {
  padding: 14px 18px 10px;
}

.post-text {
  font-family: var(--font-serif);
  font-size: 14.5px;
  line-height: 1.72;
  color: var(--text-secondary);
  margin-bottom: 10px;
  word-wrap: break-word;
}

.post-image {
  width: 100%;
  max-height: 520px;
  object-fit: contain;
  border-radius: 0;
  margin-top: 8px;
  background: var(--surface-2);
  display: block;
}

.post-video {
  width: 100%;
  max-height: 480px;
  display: block;
  margin-top: 8px;
}

/* ======================================
   POST STATS
====================================== */
.post-stats {
  display: flex;
  gap: 14px;
  font-family: var(--font);
  font-size: 12px;
  color: var(--text-muted);
  padding: 8px 18px;
  border-bottom: 1px solid var(--border);
}

/* ======================================
   POST ACTIONS (Like / Comment bar)
====================================== */
.post-actions {
  display: flex;
  gap: 4px;
  padding: 8px 14px;
  border-top: 1px solid var(--border);
}

.action-btn,
.action-btn-home {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 7px 14px;
  border: none;
  background: transparent;
  color: var(--text-muted);
  border-radius: 100px;
  font-family: var(--font);
  font-size: 13px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.18s var(--ease);
}

.action-btn:hover,
.action-btn-home:hover {
  background: var(--brand-soft);
  color: var(--brand);
}

.action-btn.liked,
.action-btn-home.liked {
  color: var(--like-red);
  background: var(--like-soft);
}

.action-btn svg,
.action-btn-home svg { font-size: 16px; }

/* ======================================
   HIGHLIGHT STATES
====================================== */
.highlight-post {
  outline: 2px solid var(--brand-light);
  background: var(--brand-soft);
  transition: background 0.3s;
}

.highlight-comment {
  background: var(--brand-soft);
  border-left: 3px solid var(--brand);
  padding-left: 8px;
  border-radius: 0 var(--radius-sm) var(--radius-sm) 0;
}

/* ======================================
   COMMENTS SECTION
====================================== */
.comments-section {
  background: linear-gradient(135deg, var(--surface-2) 0%, var(--surface) 100%);
  border-top: 3px solid;
  border-image: linear-gradient(90deg, var(--brand), var(--accent)) 1;
  padding: 28px 24px 24px;
  border-radius: 0 0 var(--radius-lg) var(--radius-lg);
  animation: slideDown 0.4s var(--ease);
  box-shadow: 
    inset 0 2px 12px rgba(21, 101, 192, 0.06),
    inset 0 -1px 3px rgba(255, 255, 255, 0.8);
  position: relative;
  overflow: hidden;
}

.comments-section::before {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  height: 1px;
  background: linear-gradient(90deg, transparent, var(--brand-light), transparent);
  opacity: 0.5;
}

@keyframes slideDown {
  from { opacity: 0; transform: translateY(-8px); }
  to   { opacity: 1; transform: translateY(0); }
}

@keyframes slideIn {
  from { opacity: 0; transform: translateX(-8px); }
  to { opacity: 1; transform: translateX(0); }
}

@keyframes float {
  0%, 100% { transform: translateY(0px); }
  50% { transform: translateY(-10px); }
}

@keyframes pulse {
  0%, 100% { opacity: 0.65; }
  50% { opacity: 1; }
}

@keyframes cardIn {
  from { opacity: 0; transform: translateY(10px); }
  to   { opacity: 1; transform: translateY(0); }
}

.comments-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 24px;
  padding: 0 0 16px 0;
  border-bottom: 2px solid var(--border);
  position: relative;
  gap: 12px;
}

.comments-header::before {
  content: '';
  position: absolute;
  bottom: -2px;
  left: 0;
  width: 80px;
  height: 3px;
  background: linear-gradient(90deg, var(--brand-light), var(--accent), var(--brand));
  border-radius: 2px;
  box-shadow: 0 0 12px rgba(21, 101, 192, 0.3);
  animation: expandWidth 0.6s var(--ease);
}

@keyframes expandWidth {
  from { width: 0; }
  to { width: 80px; }
}

.comments-header h4 {
  font-family: var(--font);
  font-size: 15px;
  font-weight: 700;
  color: var(--text-primary);
  text-transform: none;
  letter-spacing: -0.3px;
  margin: 0;
  display: flex;
  align-items: center;
  gap: 8px;
}

.comments-header h4::before {
  content: '💬';
  font-size: 16px;
}

.close-comments-btn {
  width: 40px;
  height: 40px;
  background: none;
  border: none;
  color: var(--text-muted);
  cursor: pointer;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 19px;
  transition: all 0.3s cubic-bezier(0.34, 1.56, 0.64, 1);
  flex-shrink: 0;
  position: relative;
  box-shadow: inset 0 0 0 2px transparent;
}

.close-comments-btn::before {
  content: '';
  position: absolute;
  inset: -4px;
  background: radial-gradient(circle, var(--danger-soft) 0%, transparent 70%);
  opacity: 0;
  transition: opacity 0.3s ease;
  border-radius: 50%;
  pointer-events: none;
}

.close-comments-btn:hover {
  background: linear-gradient(135deg, var(--danger-soft), rgba(239, 68, 68, 0.08));
  color: var(--danger);
  transform: scale(1.15) rotate(90deg);
  box-shadow: 0 4px 12px rgba(239, 68, 68, 0.2);
}

.close-comments-btn:hover::before {
  opacity: 0.5;
}

/* ======================================
   LOADING SKELETON
====================================== */
.comment-loading-skeleton {
  display: flex;
  gap: 12px;
  padding: 16px;
  animation: shimmer 2s ease-in-out infinite;
  background: linear-gradient(
    90deg,
    var(--border) 0%,
    var(--border-strong) 20%,
    var(--border) 40%,
    var(--border) 100%
  );
  background-size: 200% 100%;
  border-radius: var(--radius-md);
  border: 1.5px solid var(--border);
}

@keyframes shimmer {
  0% { background-position: 200% 0; }
  100% { background-position: -200% 0; }
}

.skeleton-avatar {
  width: 42px;
  height: 42px;
  border-radius: 50%;
  background: linear-gradient(90deg, var(--border-strong), var(--border));
  flex-shrink: 0;
  animation: pulse 1.8s ease-in-out infinite;
}

.skeleton-content {
  flex: 1 1;
  display: flex;
  flex-direction: column;
  gap: 10px;
}

.skeleton-line {
  height: 13px;
  background: linear-gradient(90deg, var(--border-strong), var(--border));
  border-radius: 7px;
  animation: pulse 1.8s ease-in-out infinite;
}

.skeleton-line.short {
  width: 55%;
}

/* ======================================
   EMPTY STATE
====================================== */
.comments-empty-state {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 48px 24px;
  text-align: center;
  color: var(--text-muted);
  background: linear-gradient(135deg, rgba(227, 242, 253, 0.3), rgba(211, 235, 248, 0.2));
  border-radius: var(--radius-md);
  border: 2.5px dashed var(--border-strong);
  animation: fadeInScale 0.4s var(--ease);
}

@keyframes fadeInScale {
  from { opacity: 0; transform: scale(0.95) translateY(8px); }
  to { opacity: 1; transform: scale(1) translateY(0); }
}

.empty-icon {
  font-size: 48px;
  margin-bottom: 14px;
  animation: float 3.5s ease-in-out infinite;
}

.comments-empty-state p {
  font-family: var(--font);
  font-size: 16px;
  font-weight: 700;
  margin: 0 0 8px 0;
  color: var(--text-secondary);
  letter-spacing: -0.3px;
}

.comments-empty-state span {
  font-family: var(--font);
  font-size: 13.5px;
  color: var(--text-muted);
  line-height: 1.6;
  font-weight: 500;
}

/* ======================================
   COMMENT CARDS
====================================== */
.comments-list {
  max-height: 450px;
  overflow-y: auto;
  margin-bottom: 28px;
  display: flex;
  flex-direction: column;
  gap: 14px;
  padding-right: 8px;
  position: relative;
}

.comments-list::before {
  content: '';
  position: sticky;
  top: 0;
  height: 0;
  background: linear-gradient(to bottom, var(--surface-2), transparent);
  pointer-events: none;
  z-index: 5;
}

.comments-list::-webkit-scrollbar {
  width: 8px;
}

.comments-list::-webkit-scrollbar-track {
  background: transparent;
  border-radius: 4px;
}

.comments-list::-webkit-scrollbar-thumb {
  background: linear-gradient(to bottom, var(--brand-light), var(--brand));
  border-radius: 4px;
  -webkit-transition: all 0.3s ease;
  transition: all 0.3s ease;
  box-shadow: 0 0 8px rgba(21, 101, 192, 0.2);
}

.comments-list::-webkit-scrollbar-thumb:hover {
  background: linear-gradient(to bottom, var(--brand-mid), var(--brand-light));
  box-shadow: 0 0 12px rgba(21, 101, 192, 0.35);
}

.comment-card {
  display: flex;
  flex-direction: column;
  gap: 12px;
  padding: 16px 18px;
  background: linear-gradient(135deg, rgba(255, 255, 255, 0.9), rgba(248, 250, 252, 0.8));
  border: 2px solid var(--border);
  border-radius: var(--radius-md);
  transition: all 0.35s cubic-bezier(0.34, 1.56, 0.64, 1);
  position: relative;
  overflow: hidden;
  backdrop-filter: blur(8px);
}

.comment-card::before {
  content: '';
  position: absolute;
  left: 0;
  top: 0;
  height: 100%;
  width: 4px;
  background: linear-gradient(to bottom, var(--brand), var(--brand-light), var(--accent));
  opacity: 0;
  transition: opacity 0.35s ease;
  box-shadow: 0 0 12px rgba(21, 101, 192, 0.3);
}

.comment-card::after {
  content: '';
  position: absolute;
  inset: 0;
  background: radial-gradient(circle at var(--mouse-x, 50%) var(--mouse-y, 50%), rgba(21, 101, 192, 0.05), transparent);
  opacity: 0;
  transition: opacity 0.3s ease;
  pointer-events: none;
}

.comment-card:hover {
  border-color: var(--brand-light);
  box-shadow: 
    0 8px 24px rgba(21, 101, 192, 0.16),
    inset 0 1px 0 rgba(255, 255, 255, 0.6);
  background: linear-gradient(135deg, rgba(227, 242, 253, 0.9), rgba(248, 250, 252, 0.95));
  transform: translateY(-4px) scale(1.01);
}

.comment-card:hover::before {
  opacity: 1;
}

.comment-card:hover::after {
  opacity: 1;
}

.comment-main {
  display: flex;
  gap: 12px;
  align-items: flex-start;
  position: relative;
}

.comment-avatar,
.reply-avatar {
  width: 40px;
  height: 40px;
  border-radius: 50%;
  object-fit: cover;
  border: 3px solid var(--brand-soft);
  flex-shrink: 0;
  transition: all 0.35s cubic-bezier(0.34, 1.56, 0.64, 1);
  box-shadow: 
    0 4px 16px rgba(21, 101, 192, 0.2),
    inset 0 -2px 4px rgba(0, 0, 0, 0.1);
  position: relative;
}

.comment-avatar::after {
  content: '';
  position: absolute;
  inset: 0;
  border-radius: 50%;
  background: radial-gradient(circle at 30% 30%, rgba(255, 255, 255, 0.4), transparent);
  opacity: 0;
  transition: opacity 0.3s ease;
}

.comment-card:hover .comment-avatar,
.comment-card:hover .reply-avatar {
  border-color: var(--brand-light);
  box-shadow: 
    0 6px 20px rgba(21, 101, 192, 0.35),
    inset 0 -2px 4px rgba(0, 0, 0, 0.1);
  transform: scale(1.12) rotate(3deg);
}

.comment-card:hover .comment-avatar::after {
  opacity: 1;
}

.comment-content,
.reply-content {
  flex: 1 1;
  min-width: 0;
}

.comment-bubble,
.reply-bubble {
  background: linear-gradient(135deg, rgba(238, 244, 251, 0.8), rgba(227, 242, 253, 0.6));
  border: 2px solid var(--border-strong);
  border-radius: 18px;
  padding: 14px 18px;
  position: relative;
  margin-bottom: 8px;
  box-shadow: 
    0 4px 12px rgba(21, 101, 192, 0.08),
    inset 0 1px 0 rgba(255, 255, 255, 0.8);
  transition: all 0.3s ease;
  backdrop-filter: blur(10px);
}

.comment-card:hover .comment-bubble {
  background: linear-gradient(135deg, rgba(227, 242, 253, 0.9), rgba(211, 235, 248, 0.7));
  border-color: var(--brand-light);
  box-shadow: 
    0 6px 20px rgba(21, 101, 192, 0.14),
    inset 0 1px 0 rgba(255, 255, 255, 0.9);
}

.comment-bubble::before,
.reply-bubble::before {
  content: '';
  position: absolute;
  top: 12px;
  left: -7px;
  width: 0;
  height: 0;
  border: 8px solid transparent;
  border-right-color: var(--border-strong);
  border-left: 0;
}

.comment-bubble::after,
.reply-bubble::after {
  content: '';
  position: absolute;
  top: 13px;
  left: -5px;
  width: 0;
  height: 0;
  border: 7px solid transparent;
  border-right-color: var(--surface-3);
  border-left: 0;
}

.comment-header-info,
.reply-header-info {
  display: flex;
  align-items: center;
  gap: 10px;
  margin-bottom: 6px;
  flex-wrap: wrap;
}

.comment-author,
.reply-author {
  font-family: var(--font);
  font-size: 13.5px;
  font-weight: 700;
  color: var(--text-primary);
  letter-spacing: -0.2px;
}

.comment-time,
.reply-time {
  font-family: var(--font);
  font-size: 11px;
  color: var(--text-muted);
  font-weight: 500;
  opacity: 0.8;
  transition: opacity 0.2s ease;
}

.comment-card:hover .comment-time {
  opacity: 1;
  color: var(--brand-light);
}

.comment-text,
.reply-text {
  font-family: var(--font);
  font-size: 14px;
  color: var(--text-secondary);
  line-height: 1.55;
  margin: 0;
  word-wrap: break-word;
  letter-spacing: -0.1px;
}

.comment-footer {
  display: flex;
  gap: 16px;
  margin-left: 16px;
  margin-top: 8px;
}

.comment-action-btn {
  background: none;
  border: none;
  font-family: var(--font);
  font-size: 12px;
  font-weight: 700;
  color: var(--text-muted);
  cursor: pointer;
  padding: 8px 14px;
  border-radius: 10px;
  transition: all 0.25s cubic-bezier(0.34, 1.56, 0.64, 1);
  letter-spacing: -0.3px;
  position: relative;
  overflow: hidden;
  display: inline-flex;
  align-items: center;
  gap: 4px;
}

.comment-action-btn::before {
  content: '';
  position: absolute;
  inset: 0;
  background: linear-gradient(135deg, var(--brand-soft), transparent);
  opacity: 0;
  transition: opacity 0.25s ease;
  pointer-events: none;
  z-index: -1;
}

.comment-action-btn::after {
  content: '';
  position: absolute;
  bottom: 0;
  left: 50%;
  width: 0;
  height: 2px;
  background: linear-gradient(90deg, var(--brand), var(--accent));
  transform: translateX(-50%);
  transition: width 0.25s ease;
}

.comment-action-btn:hover {
  color: var(--brand);
  background: var(--brand-soft);
  transform: translateY(-3px) scale(1.05);
  box-shadow: 0 4px 12px rgba(21, 101, 192, 0.15);
}

.comment-action-btn:hover::after {
  width: 80%;
}

.view-replies-btn:hover {
  color: var(--brand-mid);
  background: rgba(25, 118, 210, 0.1);
}

.comment-menu-btn,
.reply-menu-btn {
  background: none;
  border: none;
  color: var(--text-muted);
  cursor: pointer;
  width: 40px;
  height: 40px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  font-size: 20px;
  font-weight: bold;
  transition: all 0.3s cubic-bezier(0.34, 1.56, 0.64, 1);
  margin-left: auto;
  opacity: 0.4;
  transform: scale(0.85);
  box-shadow: inset 0 0 0 1px transparent;
}

.comment-card:hover .comment-menu-btn,
.reply-card:hover .reply-menu-btn {
  opacity: 1;
  transform: scale(1);
}

.comment-menu-btn:hover,
.reply-menu-btn:hover {
  background: linear-gradient(135deg, var(--danger-soft), rgba(239, 68, 68, 0.08));
  color: var(--danger);
  transform: scale(1.2) rotate(90deg);
  box-shadow: 0 4px 12px rgba(239, 68, 68, 0.2);
}

/* ======================================
   REPLIES
====================================== */
.replies-container {
  margin-left: 52px;
  display: flex;
  flex-direction: column;
  gap: 12px;
  padding-left: 20px;
  border-left: 4px solid;
  border-image: linear-gradient(to bottom, var(--brand-light), var(--brand-soft)) 1;
  animation: slideIn 0.3s var(--ease);
  position: relative;
}

.replies-container::before {
  content: '';
  position: absolute;
  left: -4px;
  top: 0;
  height: 100%;
  width: 4px;
  background: linear-gradient(to bottom, var(--brand-mid), var(--brand-soft), transparent);
  opacity: 0;
  transition: opacity 0.3s ease;
}

.reply-card {
  display: flex;
  gap: 10px;
  align-items: flex-start;
  padding: 14px 16px;
  background: linear-gradient(135deg, rgba(238, 244, 251, 0.7), rgba(248, 250, 252, 0.8));
  border-radius: var(--radius-md);
  border: 2px solid var(--border-strong);
  transition: all 0.3s cubic-bezier(0.34, 1.56, 0.64, 1);
  position: relative;
  backdrop-filter: blur(8px);
}

.reply-card::before {
  content: '';
  position: absolute;
  left: 0;
  top: 0;
  height: 100%;
  width: 3px;
  background: linear-gradient(to bottom, var(--brand-mid), var(--brand-soft));
  opacity: 0;
  transition: opacity 0.3s ease;
  border-radius: var(--radius-md) 0 0 var(--radius-md);
}

.reply-card:hover {
  background: linear-gradient(135deg, rgba(227, 242, 253, 0.85), rgba(211, 235, 248, 0.85));
  border-color: var(--brand-light);
  box-shadow: 0 6px 20px rgba(21, 101, 192, 0.14);
  transform: translateX(3px) translateY(-2px);
}

.reply-card:hover::before {
  opacity: 1;
}

.reply-avatar {
  width: 32px;
  height: 32px;
  border: 2px solid var(--brand-light);
}

.reply-bubble {
  background: linear-gradient(135deg, var(--surface), var(--surface-2));
  padding: 10px 14px;
  border: 1px solid var(--border);
  box-shadow: 0 1px 4px rgba(21, 101, 192, 0.05);
}

.reply-bubble::before,
.reply-bubble::after {
  display: none;
}

.reply-author {
  font-size: 12.5px;
  font-weight: 700;
}

.reply-time {
  font-size: 10.5px;
}

.reply-text {
  font-size: 13.5px;
  color: var(--text-secondary);
}

/* ======================================
   REPLY INPUT WRAPPER
====================================== */
.reply-input-wrapper {
  margin-left: 52px;
  margin-top: 8px;
  animation: fadeIn 0.2s ease;
}

@keyframes fadeIn {
  from { opacity: 0; transform: translateY(-4px); }
  to { opacity: 1; transform: translateY(0); }
}

/* ======================================
   COMMENT INPUT SECTION
====================================== */
.comment-input-section {
  border-top: 2px solid var(--border);
  padding-top: 18px;
  margin-top: 6px;
}

/* ======================================
   COMMENT INPUT
====================================== */
.comment-input-container {
  display: flex;
  align-items: flex-start;
  gap: 12px;
}

.comment-input-wrapper {
  flex: 1 1;
  display: flex;
  flex-direction: column;
  gap: 10px;
  position: relative;
  min-width: 0;
}

.comment-user-img {
  width: 40px;
  height: 40px;
  border-radius: 50%;
  object-fit: cover;
  border: 2px solid var(--brand-soft);
  flex-shrink: 0;
  box-shadow: 0 2px 6px rgba(21, 101, 192, 0.15);
}

.comment-input {
  width: 100%;
  padding: 13px 115px 13px 20px;
  border: 2.5px solid var(--border);
  border-radius: 28px;
  font-family: var(--font);
  font-size: 14px;
  color: var(--text-primary);
  background: linear-gradient(135deg, rgba(248, 250, 252, 0.8), rgba(227, 242, 253, 0.5));
  outline: none;
  transition: all 0.35s cubic-bezier(0.34, 1.56, 0.64, 1);
  box-sizing: border-box;
  resize: none;
  letter-spacing: -0.2px;
  box-shadow: 0 2px 8px rgba(21, 101, 192, 0.06);
}

.comment-input::placeholder {
  color: var(--text-muted);
  font-weight: 500;
}

.comment-input:focus {
  border-color: var(--brand-mid);
  box-shadow: 
    0 0 0 5px var(--brand-soft),
    0 4px 16px rgba(21, 101, 192, 0.15);
  transform: translateY(-3px) scale(1.01);
  background: linear-gradient(135deg, rgba(227, 242, 253, 0.9), rgba(211, 235, 248, 0.7));
}

.comment-input-actions {
  position: absolute;
  right: 12px;
  top: 50%;
  transform: translateY(-50%);
  display: flex;
  align-items: center;
  gap: 8px;
}

.emoji-btn {
  width: 38px;
  height: 38px;
  background: none;
  border: none;
  color: var(--text-muted);
  cursor: pointer;
  font-size: 20px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 50%;
  transition: all 0.3s cubic-bezier(0.34, 1.56, 0.64, 1);
  flex-shrink: 0;
  position: relative;
  box-shadow: inset 0 0 0 2px transparent;
}

.emoji-btn::before {
  content: '';
  position: absolute;
  inset: -4px;
  background: radial-gradient(circle, var(--brand-soft) 0%, transparent 70%);
  opacity: 0;
  transition: opacity 0.3s ease;
  border-radius: 50%;
  pointer-events: none;
}

.emoji-btn:hover {
  background: var(--brand-soft);
  color: var(--brand);
  transform: scale(1.2) rotate(20deg);
  box-shadow: 0 4px 12px rgba(21, 101, 192, 0.2);
}

.emoji-btn:hover::before {
  opacity: 0.5;
}

.post-comment-btn {
  padding: 9px 20px;
  background: linear-gradient(135deg, var(--brand), var(--brand-mid), var(--brand-light));
  color: white;
  border: none;
  border-radius: 22px;
  font-family: var(--font);
  font-size: 13px;
  font-weight: 700;
  cursor: pointer;
  box-shadow: 
    0 4px 16px var(--brand-glow),
    inset 0 -2px 4px rgba(0, 0, 0, 0.1),
    inset 0 1px 2px rgba(255, 255, 255, 0.3);
  transition: all 0.3s cubic-bezier(0.34, 1.56, 0.64, 1);
  white-space: nowrap;
  letter-spacing: -0.3px;
  flex-shrink: 0;
  position: relative;
  overflow: hidden;
  text-shadow: 0 1px 2px rgba(0, 0, 0, 0.1);
}

.post-comment-btn::before {
  content: '';
  position: absolute;
  inset: 0;
  background: radial-gradient(circle at 30% 30%, rgba(255, 255, 255, 0.4), transparent 70%);
  opacity: 0;
  transition: opacity 0.3s ease;
  pointer-events: none;
}

.post-comment-btn::after {
  content: '';
  position: absolute;
  inset: 0;
  background: linear-gradient(135deg, transparent, rgba(255, 255, 255, 0.2), transparent);
  opacity: 0;
  transition: opacity 0.3s ease;
  pointer-events: none;
}

.post-comment-btn:hover:not(:disabled) {
  transform: translateY(-4px) scale(1.05);
  box-shadow: 
    0 10px 28px var(--brand-glow),
    inset 0 -2px 4px rgba(0, 0, 0, 0.15),
    inset 0 1px 2px rgba(255, 255, 255, 0.4);
}

.post-comment-btn:hover:not(:disabled)::before {
  opacity: 1;
}

.post-comment-btn:hover:not(:disabled)::after {
  opacity: 1;
}

.post-comment-btn:disabled {
  opacity: 0.35;
  cursor: not-allowed;
  transform: none;
  background: linear-gradient(135deg, var(--text-muted), var(--text-muted));
  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.1);
}

/* ======================================
   REPLY INPUT
====================================== */
.reply-input-container {
  position: relative;
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 16px 18px;
  background: linear-gradient(135deg, rgba(238, 244, 251, 0.8), rgba(227, 242, 253, 0.6));
  border-radius: var(--radius-md);
  border: 2.5px solid var(--border-strong);
  box-shadow: 
    0 4px 16px rgba(21, 101, 192, 0.1),
    inset 0 1px 0 rgba(255, 255, 255, 0.8);
  transition: all 0.35s cubic-bezier(0.34, 1.56, 0.64, 1);
  backdrop-filter: blur(10px);
}

.reply-input-container:focus-within {
  border-color: var(--brand-mid);
  box-shadow: 
    0 8px 24px rgba(21, 101, 192, 0.16),
    inset 0 1px 0 rgba(255, 255, 255, 0.9);
  background: linear-gradient(135deg, rgba(227, 242, 253, 0.9), rgba(211, 235, 248, 0.7));
}

.reply-input {
  flex: 1 1;
  padding: 11px 16px;
  border: 2.5px solid var(--border);
  border-radius: 22px;
  font-family: var(--font);
  font-size: 13px;
  color: var(--text-primary);
  background: linear-gradient(135deg, rgba(248, 250, 252, 0.85), rgba(227, 242, 253, 0.5));
  outline: none;
  transition: all 0.3s cubic-bezier(0.34, 1.56, 0.64, 1);
  min-width: 0;
  letter-spacing: -0.2px;
  box-shadow: 0 2px 6px rgba(21, 101, 192, 0.04);
}

.reply-input::placeholder {
  color: var(--text-muted);
  font-weight: 500;
}

.reply-input:focus {
  border-color: var(--brand-mid);
  box-shadow: 
    0 0 0 4px var(--brand-soft),
    0 4px 14px rgba(21, 101, 192, 0.12);
  transform: translateY(-2px) scale(1.01);
  background: linear-gradient(135deg, rgba(227, 242, 253, 0.9), rgba(211, 235, 248, 0.6));
}

.reply-input-actions {
  display: flex;
  align-items: center;
  gap: 8px;
  flex-shrink: 0;
}

.send-reply-btn {
  width: 40px;
  height: 40px;
  background: linear-gradient(135deg, var(--brand), var(--brand-mid), var(--brand-light));
  color: white;
  border: none;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 17px;
  cursor: pointer;
  box-shadow: 
    0 4px 16px var(--brand-glow),
    inset 0 -2px 4px rgba(0, 0, 0, 0.1),
    inset 0 1px 2px rgba(255, 255, 255, 0.3);
  transition: all 0.3s cubic-bezier(0.34, 1.56, 0.64, 1);
  flex-shrink: 0;
  position: relative;
  overflow: hidden;
}

.send-reply-btn::before {
  content: '';
  position: absolute;
  inset: 0;
  background: radial-gradient(circle, rgba(255, 255, 255, 0.3), transparent 70%);
  opacity: 0;
  transition: opacity 0.3s ease;
  pointer-events: none;
  border-radius: 50%;
}

.send-reply-btn:hover:not(:disabled) {
  transform: scale(1.2) translateY(-3px);
  box-shadow: 
    0 8px 24px var(--brand-glow),
    inset 0 -2px 4px rgba(0, 0, 0, 0.15),
    inset 0 1px 2px rgba(255, 255, 255, 0.4);
}

.send-reply-btn:hover:not(:disabled)::before {
  opacity: 1;
}

.send-reply-btn:disabled {
  opacity: 0.35;
  cursor: not-allowed;
  transform: none;
  background: linear-gradient(135deg, var(--text-muted), var(--text-muted));
  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.1);
}

.close-reply-btn {
  width: 40px;
  height: 40px;
  background: none;
  border: none;
  color: var(--text-muted);
  cursor: pointer;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 17px;
  transition: all 0.3s cubic-bezier(0.34, 1.56, 0.64, 1);
  flex-shrink: 0;
  position: relative;
  box-shadow: inset 0 0 0 2px transparent;
}

.close-reply-btn::before {
  content: '';
  position: absolute;
  inset: -4px;
  background: radial-gradient(circle, var(--danger-soft) 0%, transparent 70%);
  opacity: 0;
  transition: opacity 0.3s ease;
  border-radius: 50%;
  pointer-events: none;
}

.close-reply-btn:hover {
  background: linear-gradient(135deg, var(--danger-soft), rgba(239, 68, 68, 0.08));
  color: var(--danger);
  transform: scale(1.15) rotate(90deg);
  box-shadow: 0 4px 12px rgba(239, 68, 68, 0.2);
}

.close-reply-btn:hover::before {
  opacity: 0.5;
}

/* ======================================
   EMOJI PICKER
====================================== */
.emoji-picker-wrapper {
  position: absolute;
  bottom: calc(100% + 10px);
  right: 0;
  z-index: 1000;
  background: var(--surface);
  border: 2.5px solid var(--border-strong);
  border-radius: var(--radius-md);
  box-shadow: 
    0 12px 32px rgba(21, 101, 192, 0.2),
    inset 0 1px 0 rgba(255, 255, 255, 0.9);
  overflow: hidden;
  animation: popIn 0.3s cubic-bezier(0.34, 1.56, 0.64, 1);
  backdrop-filter: blur(12px);
}

@keyframes popIn {
  from { opacity: 0; transform: scale(0.85) translateY(12px); }
  to { opacity: 1; transform: scale(1) translateY(0); }
}

.reply-input-container .emoji-picker-wrapper {
  bottom: calc(100% + 10px);
}

.EmojiPickerReact {
  max-width: 320px !important;
  height: 380px !important;
  --emoji-picker-category-label-bg-color: linear-gradient(90deg, var(--surface), var(--surface-3)) !important;
  --emoji-picker-skin-tone-popup-background: var(--surface-3) !important;
}

.emoji-picker-header {
  display: flex;
  justify-content: flex-end;
  padding: 8px 10px;
  border-bottom: 2px solid var(--border);
  background: linear-gradient(90deg, var(--surface), var(--surface-2));
}

.close-emoji-picker {
  width: 32px;
  height: 32px;
  background: none;
  border: none;
  color: var(--text-muted);
  cursor: pointer;
  border-radius: 50%;
  font-size: 15px;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all 0.25s cubic-bezier(0.34, 1.56, 0.64, 1);
  flex-shrink: 0;
  position: relative;
  box-shadow: inset 0 0 0 2px transparent;
}

.close-emoji-picker:hover {
  background: linear-gradient(135deg, var(--danger-soft), rgba(239, 68, 68, 0.08));
  color: var(--danger);
  transform: scale(1.15) rotate(90deg);
  box-shadow: 0 3px 10px rgba(239, 68, 68, 0.15);
}

/* ======================================
   CONFIRMATION DIALOG
====================================== */
.confirmation-dialog-overlay {
  position: fixed;
  inset: 0;
  background: rgba(13, 27, 42, 0.55);
  backdrop-filter: blur(6px);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000;
}

.confirmation-dialog {
  background: var(--surface);
  padding: 28px 32px;
  border-radius: var(--radius-lg);
  width: 92%;
  max-width: 380px;
  box-shadow: var(--shadow-lg);
  border: 1px solid var(--border-strong);
  text-align: center;
  animation: modalIn 0.25s var(--ease);
  position: relative;
  overflow: hidden;
}

.confirmation-dialog::before {
  content: '';
  display: block;
  height: 4px;
  background: linear-gradient(90deg, var(--danger), #FF8A80);
  position: absolute;
  top: 0; left: 0; right: 0;
}

@keyframes modalIn {
  from { opacity: 0; transform: scale(0.95) translateY(12px); }
  to   { opacity: 1; transform: scale(1) translateY(0); }
}

.confirmation-dialog h3 {
  font-family: var(--font);
  font-size: 17px;
  font-weight: 800;
  color: var(--text-primary);
  margin: 10px 0 8px;
}

.confirmation-dialog p {
  font-family: var(--font);
  font-size: 13.5px;
  color: var(--text-muted);
  line-height: 1.6;
  margin: 0 0 22px;
}

.confirmation-buttons {
  display: flex;
  justify-content: center;
  gap: 10px;
}

.cancel-btn {
  padding: 9px 22px;
  background: var(--surface-2);
  color: var(--text-secondary);
  border: 1.5px solid var(--border-strong);
  border-radius: 100px;
  font-family: var(--font);
  font-size: 13px;
  font-weight: 600;
  cursor: pointer;
  min-width: 90px;
  transition: all 0.18s var(--ease);
}

.cancel-btn:hover {
  background: var(--border);
  color: var(--text-primary);
}

.delete-btn-home-comment {
  padding: 9px 22px;
  background: var(--danger);
  color: white;
  border: none;
  border-radius: 100px;
  font-family: var(--font);
  font-size: 13px;
  font-weight: 700;
  cursor: pointer;
  min-width: 90px;
  box-shadow: 0 2px 8px rgba(239,68,68,0.3);
  transition: all 0.18s var(--ease);
}

.delete-btn-home-comment:hover {
  background: #DC2626;
  transform: translateY(-1px);
  box-shadow: 0 4px 14px rgba(239,68,68,0.35);
}

/* Reply stats */
.replies-summary { margin-left: 44px; margin-bottom: 4px; }

.reply-stats {
  display: flex;
  align-items: center;
  gap: 8px;
  font-family: var(--font);
  font-size: 11.5px;
  color: var(--text-muted);
}

/* ======================================
   RESPONSIVE
====================================== */
@media (max-width: 1024px) {
  .linkedin-feed { max-width: 90%; padding: 16px; }
  .post-profile-img { width: 40px; height: 40px; }
  .comment-user-img, .reply-user-img { width: 32px; height: 32px; }
}

@media (max-width: 768px) {
  .linkedin-feed { padding: 12px 10px; margin: 80px auto 0; max-width: 100%; }
  .linkedin-post { border-radius: var(--radius-md); }
  .post-header { padding: 12px 14px 10px; }
  .post-content { padding: 12px 14px 8px; }
  .post-profile-img { width: 38px; height: 38px; }
  .comment-user-img, .reply-user-img { width: 30px; height: 30px; }
  .comments-section { padding: 12px 14px; }
  .reply-input-container { margin-left: 36px; }
  .comment-actions { margin-left: 36px; }
  .replies-list { margin-left: 36px; }
}

@media (max-width: 480px) {
  .linkedin-feed { padding: 10px 8px; margin: 70px auto 0; }
  .linkedin-post { border-radius: var(--radius-sm); margin-bottom: 12px; }
  .post-header { padding: 10px 12px; }
  .post-content { padding: 10px 12px; }
  .comment-input { font-size: 13px; padding: 9px 80px 9px 14px; }
  .reply-input { font-size: 12.5px; }
  .post-comment-btn { font-size: 11.5px; padding: 5px 10px; }
  .action-btn, .action-btn-home { padding: 6px 10px; font-size: 12px; }
  .confirmation-dialog { padding: 22px 20px; }
  .emoji-picker-wrapper { max-width: 92vw; right: 0; left: 0; margin: auto; }
  .loading-container-home { height: 150px; }
  .loading-spinner-home { width: 40px; height: 40px; }
}

@media (max-width: 375px) {
  .comment-input, .reply-input { font-size: 12px; }
  .post-comment-btn, .send-reply-btn { font-size: 11px; }
  .linkedin-feed { padding: 8px 6px; }
}`, "",{"version":3,"sources":["webpack://./src/components/Home.css"],"names":[],"mappings":"AAEA;;wCAEwC;AACxC;EACE,yBAAyB;EACzB,yBAAyB;EACzB,yBAAyB;EACzB,yBAAyB;EACzB,0CAA0C;EAC1C,yBAAyB;EACzB,yBAAyB;EACzB,yBAAyB;EACzB,yBAAyB;EACzB,yBAAyB;EACzB,yBAAyB;EACzB,yBAAyB;EACzB,yBAAyB;EACzB,yBAAyB;EACzB,yBAAyB;EACzB,yBAAyB;EACzB,yBAAyB;EACzB,yBAAyB;EACzB,yBAAyB;EACzB,iDAAiD;EACjD,+BAA+B;EAC/B,+CAA+C;EAC/C,qBAAqB;EACrB,sBAAsB;EACtB,sBAAsB;EACtB,mFAAmF;EACnF,qFAAqF;EACrF,qFAAqF;AACvF;;AAEA,IAAI,sBAAsB,EAAE;;AAE5B;;wCAEwC;AACxC;EACE,wBAAwB;EACxB,WAAW;EACX,gBAAgB;EAChB,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;;wCAEwC;AACxC;EACE,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,mBAAmB;EACnB,aAAa;EACb,WAAW;EACX,SAAS;AACX;;AAEA;EACE,mCAAmC;EACnC,kCAAkC;EAClC,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,qCAAqC;AACvC;;AAEA;EACE,OAAO,uBAAuB,EAAE;EAChC,OAAO,yBAAyB,EAAE;AACpC;;AAEA;;wCAEwC;AACxC;;EAEE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB,kBAAkB;EAClB,0BAA0B;EAC1B,sCAAsC;EACtC,+BAA+B;EAC/B,4BAA4B;EAC5B,iBAAiB;EACjB,gBAAgB;EAChB,wBAAwB;EACxB,wBAAwB;EACxB,SAAS;AACX;;AAEA;EACE,eAAe;EACf,yBAAyB;EACzB,kBAAkB;EAClB,YAAY;AACd;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,4BAA4B;EAC5B,SAAS;AACX;;AAEA;EACE,iBAAiB;EACjB,wBAAwB;EACxB,SAAS;EACT,iBAAiB;AACnB;;AAEA;EACE,mEAAmE;EACnE,YAAY;EACZ,YAAY;EACZ,oBAAoB;EACpB,kBAAkB;EAClB,eAAe;EACf,eAAe;EACf,wBAAwB;EACxB,iBAAiB;EACjB,gBAAgB;EAChB,wCAAwC;EACxC,gCAAgC;AAClC;;AAEA;EACE,2BAA2B;EAC3B,wCAAwC;AAC1C;;AAEA;;wCAEwC;AACxC;EACE,0BAA0B;EAC1B,+BAA+B;EAC/B,+BAA+B;EAC/B,mBAAmB;EACnB,gBAAgB;EAChB,4BAA4B;EAC5B,qEAAqE;EACrE,kBAAkB;EAClB,uCAAuC;AACzC;;AAEA;EACE,OAAO,UAAU,EAAE,2BAA2B,EAAE;EAChD,OAAO,UAAU,EAAE,wBAAwB,EAAE;AAC/C;;AAEA,sCAAsC;AACtC;EACE,WAAW;EACX,kBAAkB;EAClB,MAAM,EAAE,OAAO,EAAE,QAAQ;EACzB,WAAW;EACX,mFAAmF;EACnF,oBAAoB;EACpB,sBAAsB;EACtB,sCAAsC;EACtC,UAAU;AACZ;;AAEA,+BAA+B,oBAAoB,EAAE;AACrD;EACE,2BAA2B;EAC3B,4BAA4B;AAC9B;;AAEA;;wCAEwC;AACxC;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,SAAS;EACT,sCAAsC;AACxC;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,eAAe;EACf,wBAAwB;EACxB,oBAAoB;EACpB,uBAAuB;EACvB,YAAY;EACZ,4BAA4B;EAC5B,SAAO;EACP,YAAY;AACd;;AAEA,mBAAmB,4BAA4B,EAAE;;AAEjD;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,iBAAiB;EACjB,mCAAmC;EACnC,0CAA0C;EAC1C,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,YAAY;AACd;;AAEA;EACE,wBAAwB;EACxB,gBAAgB;EAChB,iBAAiB;EACjB,0BAA0B;EAC1B,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;;EAEE,eAAe;EACf,wBAAwB;EACxB,SAAS;AACX;;AAEA,kBAAkB;AAClB;EACE,iBAAiB;EACjB,cAAc;EACd,iBAAiB;EACjB,oBAAoB;EACpB,uBAAuB;EACvB,mBAAmB;EACnB,wBAAwB;EACxB,gBAAgB;EAChB,eAAe;EACf,eAAe;EACf,gCAAgC;EAChC,gCAAgC;EAChC,mBAAmB;AACrB;;AAEA;EACE,wBAAwB;EACxB,YAAY;EACZ,wCAAwC;AAC1C;;AAEA;EACE,YAAY;EACZ,mBAAmB;EACnB,eAAe;AACjB;;AAEA,wBAAwB;AACxB;EACE,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,gBAAgB;EAChB,YAAY;EACZ,wBAAwB;EACxB,eAAe;EACf,eAAe;EACf,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,qBAAqB;AACvB;;AAEA;EACE,4BAA4B;EAC5B,mBAAmB;AACrB;;AAEA,aAAa;AACb;;EAEE,kBAAkB;EAClB,SAAS;EACT,QAAQ;EACR,0BAA0B;EAC1B,sCAAsC;EACtC,+BAA+B;EAC/B,4BAA4B;EAC5B,YAAY;EACZ,YAAY;EACZ,gBAAgB;EAChB,mCAAmC;AACrC;;AAEA;EACE,OAAO,UAAU,EAAE,uCAAuC,EAAE;EAC5D,OAAO,UAAU,EAAE,iCAAiC,EAAE;AACxD;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,WAAW;EACX,kBAAkB;EAClB,gBAAgB;EAChB,YAAY;EACZ,wBAAwB;EACxB,eAAe;EACf,gBAAgB;EAChB,4BAA4B;EAC5B,eAAe;EACf,gBAAgB;EAChB,4BAA4B;AAC9B;;AAEA;EACE,4BAA4B;EAC5B,mBAAmB;AACrB;;AAEA;;wCAEwC;AACxC;EACE,uBAAuB;AACzB;;AAEA;EACE,8BAA8B;EAC9B,iBAAiB;EACjB,iBAAiB;EACjB,4BAA4B;EAC5B,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,WAAW;EACX,iBAAiB;EACjB,mBAAmB;EACnB,gBAAgB;EAChB,eAAe;EACf,4BAA4B;EAC5B,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,iBAAiB;EACjB,cAAc;EACd,eAAe;AACjB;;AAEA;;wCAEwC;AACxC;EACE,aAAa;EACb,SAAS;EACT,wBAAwB;EACxB,eAAe;EACf,wBAAwB;EACxB,iBAAiB;EACjB,sCAAsC;AACxC;;AAEA;;wCAEwC;AACxC;EACE,aAAa;EACb,QAAQ;EACR,iBAAiB;EACjB,mCAAmC;AACrC;;AAEA;;EAEE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,iBAAiB;EACjB,YAAY;EACZ,uBAAuB;EACvB,wBAAwB;EACxB,oBAAoB;EACpB,wBAAwB;EACxB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,iCAAiC;AACnC;;AAEA;;EAEE,6BAA6B;EAC7B,mBAAmB;AACrB;;AAEA;;EAEE,sBAAsB;EACtB,4BAA4B;AAC9B;;AAEA;uBACuB,eAAe,EAAE;;AAExC;;wCAEwC;AACxC;EACE,qCAAqC;EACrC,6BAA6B;EAC7B,2BAA2B;AAC7B;;AAEA;EACE,6BAA6B;EAC7B,mCAAmC;EACnC,iBAAiB;EACjB,oDAAoD;AACtD;;AAEA;;wCAEwC;AACxC;EACE,6EAA6E;EAC7E,qBAAqB;EACrB,mEAAmE;EACnE,uBAAuB;EACvB,oDAAoD;EACpD,qCAAqC;EACrC;;6CAE2C;EAC3C,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,QAAQ;EACR,WAAW;EACX,gFAAgF;EAChF,YAAY;AACd;;AAEA;EACE,OAAO,UAAU,EAAE,2BAA2B,EAAE;EAChD,OAAO,UAAU,EAAE,wBAAwB,EAAE;AAC/C;;AAEA;EACE,OAAO,UAAU,EAAE,2BAA2B,EAAE;EAChD,KAAK,UAAU,EAAE,wBAAwB,EAAE;AAC7C;;AAEA;EACE,WAAW,0BAA0B,EAAE;EACvC,MAAM,4BAA4B,EAAE;AACtC;;AAEA;EACE,WAAW,aAAa,EAAE;EAC1B,MAAM,UAAU,EAAE;AACpB;;AAEA;EACE,OAAO,UAAU,EAAE,2BAA2B,EAAE;EAChD,OAAO,UAAU,EAAE,wBAAwB,EAAE;AAC/C;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,mBAAmB;EACnB,mBAAmB;EACnB,sCAAsC;EACtC,kBAAkB;EAClB,SAAS;AACX;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,YAAY;EACZ,OAAO;EACP,WAAW;EACX,WAAW;EACX,mFAAmF;EACnF,kBAAkB;EAClB,4CAA4C;EAC5C,uCAAuC;AACzC;;AAEA;EACE,OAAO,QAAQ,EAAE;EACjB,KAAK,WAAW,EAAE;AACpB;;AAEA;EACE,wBAAwB;EACxB,eAAe;EACf,gBAAgB;EAChB,0BAA0B;EAC1B,oBAAoB;EACpB,sBAAsB;EACtB,SAAS;EACT,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,aAAa;EACb,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,gBAAgB;EAChB,YAAY;EACZ,wBAAwB;EACxB,eAAe;EACf,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,sDAAsD;EACtD,cAAc;EACd,kBAAkB;EAClB,uCAAuC;AACzC;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,WAAW;EACX,2EAA2E;EAC3E,UAAU;EACV,6BAA6B;EAC7B,kBAAkB;EAClB,oBAAoB;AACtB;;AAEA;EACE,gFAAgF;EAChF,oBAAoB;EACpB,oCAAoC;EACpC,6CAA6C;AAC/C;;AAEA;EACE,YAAY;AACd;;AAEA;;wCAEwC;AACxC;EACE,aAAa;EACb,SAAS;EACT,aAAa;EACb,0CAA0C;EAC1C;;;;;;GAMC;EACD,0BAA0B;EAC1B,+BAA+B;EAC/B,iCAAiC;AACnC;;AAEA;EACE,KAAK,2BAA2B,EAAE;EAClC,OAAO,4BAA4B,EAAE;AACvC;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,uEAAuE;EACvE,cAAc;EACd,0CAA0C;AAC5C;;AAEA;EACE,SAAO;EACP,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,YAAY;EACZ,uEAAuE;EACvE,kBAAkB;EAClB,0CAA0C;AAC5C;;AAEA;EACE,UAAU;AACZ;;AAEA;;wCAEwC;AACxC;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB,kBAAkB;EAClB,wBAAwB;EACxB,uFAAuF;EACvF,+BAA+B;EAC/B,yCAAyC;EACzC,uCAAuC;AACzC;;AAEA;EACE,OAAO,UAAU,EAAE,sCAAsC,EAAE;EAC3D,KAAK,UAAU,EAAE,iCAAiC,EAAE;AACtD;;AAEA;EACE,eAAe;EACf,mBAAmB;EACnB,0CAA0C;AAC5C;;AAEA;EACE,wBAAwB;EACxB,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,4BAA4B;EAC5B,sBAAsB;AACxB;;AAEA;EACE,wBAAwB;EACxB,iBAAiB;EACjB,wBAAwB;EACxB,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;;wCAEwC;AACxC;EACE,iBAAiB;EACjB,gBAAgB;EAChB,mBAAmB;EACnB,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,MAAM;EACN,SAAS;EACT,qEAAqE;EACrE,oBAAoB;EACpB,UAAU;AACZ;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,uBAAuB;EACvB,kBAAkB;AACpB;;AAEA;EACE,wEAAwE;EACxE,kBAAkB;EAClB,iCAAyB;EAAzB,yBAAyB;EACzB,2CAA2C;AAC7C;;AAEA;EACE,4EAA4E;EAC5E,6CAA6C;AAC/C;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,kBAAkB;EAClB,uFAAuF;EACvF,+BAA+B;EAC/B,+BAA+B;EAC/B,uDAAuD;EACvD,kBAAkB;EAClB,gBAAgB;EAChB,0BAA0B;AAC5B;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,OAAO;EACP,MAAM;EACN,YAAY;EACZ,UAAU;EACV,uFAAuF;EACvF,UAAU;EACV,8BAA8B;EAC9B,4CAA4C;AAC9C;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,QAAQ;EACR,qHAAqH;EACrH,UAAU;EACV,6BAA6B;EAC7B,oBAAoB;AACtB;;AAEA;EACE,gCAAgC;EAChC;;0CAEwC;EACxC,wFAAwF;EACxF,uCAAuC;AACzC;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,aAAa;EACb,SAAS;EACT,uBAAuB;EACvB,kBAAkB;AACpB;;AAEA;;EAEE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,iBAAiB;EACjB,mCAAmC;EACnC,cAAc;EACd,uDAAuD;EACvD;;uCAEqC;EACrC,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,QAAQ;EACR,kBAAkB;EAClB,qFAAqF;EACrF,UAAU;EACV,6BAA6B;AAC/B;;AAEA;;EAEE,gCAAgC;EAChC;;uCAEqC;EACrC,mCAAmC;AACrC;;AAEA;EACE,UAAU;AACZ;;AAEA;;EAEE,SAAO;EACP,YAAY;AACd;;AAEA;;EAEE,uFAAuF;EACvF,sCAAsC;EACtC,mBAAmB;EACnB,kBAAkB;EAClB,kBAAkB;EAClB,kBAAkB;EAClB;;0CAEwC;EACxC,yBAAyB;EACzB,2BAA2B;AAC7B;;AAEA;EACE,uFAAuF;EACvF,gCAAgC;EAChC;;0CAEwC;AAC1C;;AAEA;;EAEE,WAAW;EACX,kBAAkB;EAClB,SAAS;EACT,UAAU;EACV,QAAQ;EACR,SAAS;EACT,6BAA6B;EAC7B,wCAAwC;EACxC,cAAc;AAChB;;AAEA;;EAEE,WAAW;EACX,kBAAkB;EAClB,SAAS;EACT,UAAU;EACV,QAAQ;EACR,SAAS;EACT,6BAA6B;EAC7B,oCAAoC;EACpC,cAAc;AAChB;;AAEA;;EAEE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,kBAAkB;EAClB,eAAe;AACjB;;AAEA;;EAEE,wBAAwB;EACxB,iBAAiB;EACjB,gBAAgB;EAChB,0BAA0B;EAC1B,sBAAsB;AACxB;;AAEA;;EAEE,wBAAwB;EACxB,eAAe;EACf,wBAAwB;EACxB,gBAAgB;EAChB,YAAY;EACZ,6BAA6B;AAC/B;;AAEA;EACE,UAAU;EACV,yBAAyB;AAC3B;;AAEA;;EAEE,wBAAwB;EACxB,eAAe;EACf,4BAA4B;EAC5B,iBAAiB;EACjB,SAAS;EACT,qBAAqB;EACrB,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,iBAAiB;EACjB,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,wBAAwB;EACxB,eAAe;EACf,gBAAgB;EAChB,wBAAwB;EACxB,eAAe;EACf,iBAAiB;EACjB,mBAAmB;EACnB,uDAAuD;EACvD,sBAAsB;EACtB,kBAAkB;EAClB,gBAAgB;EAChB,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,QAAQ;EACR,mEAAmE;EACnE,UAAU;EACV,8BAA8B;EAC9B,oBAAoB;EACpB,WAAW;AACb;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,SAAS;EACT,SAAS;EACT,QAAQ;EACR,WAAW;EACX,+DAA+D;EAC/D,2BAA2B;EAC3B,4BAA4B;AAC9B;;AAEA;EACE,mBAAmB;EACnB,6BAA6B;EAC7B,uCAAuC;EACvC,+CAA+C;AACjD;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,uBAAuB;EACvB,mCAAmC;AACrC;;AAEA;;EAEE,gBAAgB;EAChB,YAAY;EACZ,wBAAwB;EACxB,eAAe;EACf,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,cAAc;EACd,eAAe;EACf,iBAAiB;EACjB,sDAAsD;EACtD,iBAAiB;EACjB,YAAY;EACZ,sBAAsB;EACtB,uCAAuC;AACzC;;AAEA;;EAEE,UAAU;EACV,mBAAmB;AACrB;;AAEA;;EAEE,gFAAgF;EAChF,oBAAoB;EACpB,mCAAmC;EACnC,6CAA6C;AAC/C;;AAEA;;wCAEwC;AACxC;EACE,iBAAiB;EACjB,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,kBAAkB;EAClB,sBAAsB;EACtB,iFAAiF;EACjF,mCAAmC;EACnC,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,UAAU;EACV,MAAM;EACN,YAAY;EACZ,UAAU;EACV,wFAAwF;EACxF,UAAU;EACV,6BAA6B;AAC/B;;AAEA;EACE,aAAa;EACb,SAAS;EACT,uBAAuB;EACvB,kBAAkB;EAClB,uFAAuF;EACvF,+BAA+B;EAC/B,sCAAsC;EACtC,sDAAsD;EACtD,kBAAkB;EAClB,0BAA0B;AAC5B;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,OAAO;EACP,MAAM;EACN,YAAY;EACZ,UAAU;EACV,2EAA2E;EAC3E,UAAU;EACV,6BAA6B;EAC7B,oDAAoD;AACtD;;AAEA;EACE,yFAAyF;EACzF,gCAAgC;EAChC,+CAA+C;EAC/C,2CAA2C;AAC7C;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,oCAAoC;AACtC;;AAEA;EACE,qEAAqE;EACrE,kBAAkB;EAClB,+BAA+B;EAC/B,8CAA8C;AAChD;;AAEA;;EAEE,aAAa;AACf;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,iBAAiB;EACjB,4BAA4B;AAC9B;;AAEA;;wCAEwC;AACxC;EACE,iBAAiB;EACjB,eAAe;EACf,2BAA2B;AAC7B;;AAEA;EACE,OAAO,UAAU,EAAE,2BAA2B,EAAE;EAChD,KAAK,UAAU,EAAE,wBAAwB,EAAE;AAC7C;;AAEA;;wCAEwC;AACxC;EACE,mCAAmC;EACnC,iBAAiB;EACjB,eAAe;AACjB;;AAEA;;wCAEwC;AACxC;EACE,aAAa;EACb,uBAAuB;EACvB,SAAS;AACX;;AAEA;EACE,SAAO;EACP,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,kBAAkB;EAClB,YAAY;AACd;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,iBAAiB;EACjB,mCAAmC;EACnC,cAAc;EACd,8CAA8C;AAChD;;AAEA;EACE,WAAW;EACX,6BAA6B;EAC7B,iCAAiC;EACjC,mBAAmB;EACnB,wBAAwB;EACxB,eAAe;EACf,0BAA0B;EAC1B,uFAAuF;EACvF,aAAa;EACb,uDAAuD;EACvD,sBAAsB;EACtB,YAAY;EACZ,sBAAsB;EACtB,8CAA8C;AAChD;;AAEA;EACE,wBAAwB;EACxB,gBAAgB;AAClB;;AAEA;EACE,8BAA8B;EAC9B;;uCAEqC;EACrC,uCAAuC;EACvC,uFAAuF;AACzF;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,QAAQ;EACR,2BAA2B;EAC3B,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,gBAAgB;EAChB,YAAY;EACZ,wBAAwB;EACxB,eAAe;EACf,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB,sDAAsD;EACtD,cAAc;EACd,kBAAkB;EAClB,uCAAuC;AACzC;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,WAAW;EACX,0EAA0E;EAC1E,UAAU;EACV,6BAA6B;EAC7B,kBAAkB;EAClB,oBAAoB;AACtB;;AAEA;EACE,6BAA6B;EAC7B,mBAAmB;EACnB,mCAAmC;EACnC,8CAA8C;AAChD;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,iBAAiB;EACjB,uFAAuF;EACvF,YAAY;EACZ,YAAY;EACZ,mBAAmB;EACnB,wBAAwB;EACxB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf;;;4CAG0C;EAC1C,sDAAsD;EACtD,mBAAmB;EACnB,sBAAsB;EACtB,cAAc;EACd,kBAAkB;EAClB,gBAAgB;EAChB,yCAAyC;AAC3C;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,QAAQ;EACR,yFAAyF;EACzF,UAAU;EACV,6BAA6B;EAC7B,oBAAoB;AACtB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,QAAQ;EACR,uFAAuF;EACvF,UAAU;EACV,6BAA6B;EAC7B,oBAAoB;AACtB;;AAEA;EACE,uCAAuC;EACvC;;;4CAG0C;AAC5C;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,eAAe;EACf,yEAAyE;EACzE,wCAAwC;AAC1C;;AAEA;;wCAEwC;AACxC;EACE,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,kBAAkB;EAClB,uFAAuF;EACvF,+BAA+B;EAC/B,wCAAwC;EACxC;;0CAEwC;EACxC,uDAAuD;EACvD,2BAA2B;AAC7B;;AAEA;EACE,8BAA8B;EAC9B;;0CAEwC;EACxC,uFAAuF;AACzF;;AAEA;EACE,SAAO;EACP,kBAAkB;EAClB,iCAAiC;EACjC,mBAAmB;EACnB,wBAAwB;EACxB,eAAe;EACf,0BAA0B;EAC1B,wFAAwF;EACxF,aAAa;EACb,sDAAsD;EACtD,YAAY;EACZ,sBAAsB;EACtB,8CAA8C;AAChD;;AAEA;EACE,wBAAwB;EACxB,gBAAgB;AAClB;;AAEA;EACE,8BAA8B;EAC9B;;uCAEqC;EACrC,uCAAuC;EACvC,uFAAuF;AACzF;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,uFAAuF;EACvF,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,eAAe;EACf;;;4CAG0C;EAC1C,sDAAsD;EACtD,cAAc;EACd,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,QAAQ;EACR,8EAA8E;EAC9E,UAAU;EACV,6BAA6B;EAC7B,oBAAoB;EACpB,kBAAkB;AACpB;;AAEA;EACE,sCAAsC;EACtC;;;4CAG0C;AAC5C;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,eAAe;EACf,yEAAyE;EACzE,wCAAwC;AAC1C;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,gBAAgB;EAChB,YAAY;EACZ,wBAAwB;EACxB,eAAe;EACf,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,sDAAsD;EACtD,cAAc;EACd,kBAAkB;EAClB,uCAAuC;AACzC;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,WAAW;EACX,2EAA2E;EAC3E,UAAU;EACV,6BAA6B;EAC7B,kBAAkB;EAClB,oBAAoB;AACtB;;AAEA;EACE,gFAAgF;EAChF,oBAAoB;EACpB,oCAAoC;EACpC,6CAA6C;AAC/C;;AAEA;EACE,YAAY;AACd;;AAEA;;wCAEwC;AACxC;EACE,kBAAkB;EAClB,yBAAyB;EACzB,QAAQ;EACR,aAAa;EACb,0BAA0B;EAC1B,wCAAwC;EACxC,+BAA+B;EAC/B;;0CAEwC;EACxC,gBAAgB;EAChB,uDAAuD;EACvD,2BAA2B;AAC7B;;AAEA;EACE,OAAO,UAAU,EAAE,uCAAuC,EAAE;EAC5D,KAAK,UAAU,EAAE,iCAAiC,EAAE;AACtD;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,2BAA2B;EAC3B,wBAAwB;EACxB,2GAA2G;EAC3G,sEAAsE;AACxE;;AAEA;EACE,aAAa;EACb,yBAAyB;EACzB,iBAAiB;EACjB,sCAAsC;EACtC,oEAAoE;AACtE;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,gBAAgB;EAChB,YAAY;EACZ,wBAAwB;EACxB,eAAe;EACf,kBAAkB;EAClB,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,uDAAuD;EACvD,cAAc;EACd,kBAAkB;EAClB,uCAAuC;AACzC;;AAEA;EACE,gFAAgF;EAChF,oBAAoB;EACpB,oCAAoC;EACpC,8CAA8C;AAChD;;AAEA;;wCAEwC;AACxC;EACE,eAAe;EACf,QAAQ;EACR,kCAAkC;EAClC,0BAA0B;EAC1B,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,aAAa;AACf;;AAEA;EACE,0BAA0B;EAC1B,kBAAkB;EAClB,+BAA+B;EAC/B,UAAU;EACV,gBAAgB;EAChB,4BAA4B;EAC5B,sCAAsC;EACtC,kBAAkB;EAClB,oCAAoC;EACpC,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,cAAc;EACd,WAAW;EACX,0DAA0D;EAC1D,kBAAkB;EAClB,MAAM,EAAE,OAAO,EAAE,QAAQ;AAC3B;;AAEA;EACE,OAAO,UAAU,EAAE,uCAAuC,EAAE;EAC5D,OAAO,UAAU,EAAE,iCAAiC,EAAE;AACxD;;AAEA;EACE,wBAAwB;EACxB,eAAe;EACf,gBAAgB;EAChB,0BAA0B;EAC1B,kBAAkB;AACpB;;AAEA;EACE,wBAAwB;EACxB,iBAAiB;EACjB,wBAAwB;EACxB,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,SAAS;AACX;;AAEA;EACE,iBAAiB;EACjB,4BAA4B;EAC5B,4BAA4B;EAC5B,wCAAwC;EACxC,oBAAoB;EACpB,wBAAwB;EACxB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,eAAe;EACf,iCAAiC;AACnC;;AAEA;EACE,yBAAyB;EACzB,0BAA0B;AAC5B;;AAEA;EACE,iBAAiB;EACjB,yBAAyB;EACzB,YAAY;EACZ,YAAY;EACZ,oBAAoB;EACpB,wBAAwB;EACxB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,eAAe;EACf,yCAAyC;EACzC,iCAAiC;AACnC;;AAEA;EACE,mBAAmB;EACnB,2BAA2B;EAC3B,2CAA2C;AAC7C;;AAEA,gBAAgB;AAChB,mBAAmB,iBAAiB,EAAE,kBAAkB,EAAE;;AAE1D;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,wBAAwB;EACxB,iBAAiB;EACjB,wBAAwB;AAC1B;;AAEA;;wCAEwC;AACxC;EACE,iBAAiB,cAAc,EAAE,aAAa,EAAE;EAChD,oBAAoB,WAAW,EAAE,YAAY,EAAE;EAC/C,qCAAqC,WAAW,EAAE,YAAY,EAAE;AAClE;;AAEA;EACE,iBAAiB,kBAAkB,EAAE,mBAAmB,EAAE,eAAe,EAAE;EAC3E,iBAAiB,+BAA+B,EAAE;EAClD,eAAe,uBAAuB,EAAE;EACxC,gBAAgB,sBAAsB,EAAE;EACxC,oBAAoB,WAAW,EAAE,YAAY,EAAE;EAC/C,qCAAqC,WAAW,EAAE,YAAY,EAAE;EAChE,oBAAoB,kBAAkB,EAAE;EACxC,yBAAyB,iBAAiB,EAAE;EAC5C,mBAAmB,iBAAiB,EAAE;EACtC,gBAAgB,iBAAiB,EAAE;AACrC;;AAEA;EACE,iBAAiB,iBAAiB,EAAE,mBAAmB,EAAE;EACzD,iBAAiB,+BAA+B,EAAE,mBAAmB,EAAE;EACvE,eAAe,kBAAkB,EAAE;EACnC,gBAAgB,kBAAkB,EAAE;EACpC,iBAAiB,eAAe,EAAE,0BAA0B,EAAE;EAC9D,eAAe,iBAAiB,EAAE;EAClC,oBAAoB,iBAAiB,EAAE,iBAAiB,EAAE;EAC1D,gCAAgC,iBAAiB,EAAE,eAAe,EAAE;EACpE,uBAAuB,kBAAkB,EAAE;EAC3C,wBAAwB,eAAe,EAAE,QAAQ,EAAE,OAAO,EAAE,YAAY,EAAE;EAC1E,0BAA0B,aAAa,EAAE;EACzC,wBAAwB,WAAW,EAAE,YAAY,EAAE;AACrD;;AAEA;EACE,+BAA+B,eAAe,EAAE;EAChD,qCAAqC,eAAe,EAAE;EACtD,iBAAiB,gBAAgB,EAAE;AACrC","sourcesContent":["@import url('https://fonts.googleapis.com/css2?family=Plus+Jakarta+Sans:wght@300;400;500;600;700;800&family=Lora:ital,wght@0,400;0,600;1,400&display=swap');\n\n/* ======================================\n   DESIGN TOKENS — Pyate Blue Brand\n====================================== */\n:root {\n  --brand:          #1565C0;\n  --brand-mid:      #1976D2;\n  --brand-light:    #42A5F5;\n  --brand-soft:     #E3F2FD;\n  --brand-glow:     rgba(21, 101, 192, 0.18);\n  --accent:         #00BCD4;\n  --surface:        #ffffff;\n  --surface-2:      #F8FAFC;\n  --surface-3:      #EEF4FB;\n  --border:         #DBEAFE;\n  --border-strong:  #BFDBFE;\n  --text-primary:   #0D1B2A;\n  --text-secondary: #3B5270;\n  --text-muted:     #7A96B2;\n  --danger:         #EF4444;\n  --danger-soft:    #FEF2F2;\n  --like-red:       #E91E63;\n  --like-soft:      #FCE4EC;\n  --success:        #22C55E;\n  --font:           'Plus Jakarta Sans', sans-serif;\n  --font-serif:     'Lora', serif;\n  --ease:           cubic-bezier(0.16, 1, 0.3, 1);\n  --radius-sm:      8px;\n  --radius-md:      14px;\n  --radius-lg:      20px;\n  --shadow-sm:      0 1px 4px rgba(21,101,192,0.07), 0 4px 14px rgba(21,101,192,0.05);\n  --shadow-md:      0 4px 20px rgba(21,101,192,0.12), 0 12px 36px rgba(21,101,192,0.07);\n  --shadow-lg:      0 8px 36px rgba(21,101,192,0.16), 0 28px 60px rgba(21,101,192,0.09);\n}\n\n* { box-sizing: border-box; }\n\n/* ======================================\n   FEED CONTAINER\n====================================== */\n.linkedin-feed {\n  font-family: var(--font);\n  width: 100%;\n  max-width: 620px;\n  margin: 80px auto 0;\n  padding: 20px 16px 60px;\n}\n\n/* ======================================\n   LOADING\n====================================== */\n.loading-container-home {\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  align-items: center;\n  height: 300px;\n  width: 100%;\n  gap: 16px;\n}\n\n.loading-spinner-home {\n  border: 4px solid var(--brand-soft);\n  border-top: 4px solid var(--brand);\n  border-radius: 50%;\n  width: 52px;\n  height: 52px;\n  animation: spin 0.85s linear infinite;\n}\n\n@keyframes spin {\n  0%   { transform: rotate(0deg); }\n  100% { transform: rotate(360deg); }\n}\n\n/* ======================================\n   EMPTY / NO POSTS STATE\n====================================== */\n.no-posts,\n.empty-posts {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  padding: 48px 24px;\n  text-align: center;\n  background: var(--surface);\n  border: 1px solid var(--border-strong);\n  border-radius: var(--radius-lg);\n  box-shadow: var(--shadow-sm);\n  margin: 20px auto;\n  max-width: 420px;\n  font-family: var(--font);\n  color: var(--text-muted);\n  gap: 10px;\n}\n\n.empty-posts-icon {\n  font-size: 48px;\n  color: var(--brand-light);\n  margin-bottom: 6px;\n  opacity: 0.7;\n}\n\n.empty-posts h3 {\n  font-size: 16px;\n  font-weight: 700;\n  color: var(--text-secondary);\n  margin: 0;\n}\n\n.empty-posts p {\n  font-size: 13.5px;\n  color: var(--text-muted);\n  margin: 0;\n  line-height: 1.55;\n}\n\n.update-location-btn {\n  background: linear-gradient(135deg, var(--brand), var(--brand-mid));\n  color: white;\n  border: none;\n  border-radius: 100px;\n  padding: 10px 22px;\n  margin-top: 8px;\n  cursor: pointer;\n  font-family: var(--font);\n  font-size: 13.5px;\n  font-weight: 700;\n  box-shadow: 0 3px 12px var(--brand-glow);\n  transition: all 0.2s var(--ease);\n}\n\n.update-location-btn:hover {\n  transform: translateY(-2px);\n  box-shadow: 0 6px 20px var(--brand-glow);\n}\n\n/* ======================================\n   POST CARD\n====================================== */\n.linkedin-post {\n  background: var(--surface);\n  border: 1px solid var(--border);\n  border-radius: var(--radius-lg);\n  margin-bottom: 18px;\n  overflow: hidden;\n  box-shadow: var(--shadow-sm);\n  transition: transform 0.25s var(--ease), box-shadow 0.25s var(--ease);\n  position: relative;\n  animation: cardIn 0.3s var(--ease) both;\n}\n\n@keyframes cardIn {\n  from { opacity: 0; transform: translateY(10px); }\n  to   { opacity: 1; transform: translateY(0); }\n}\n\n/* Blue gradient top stripe on hover */\n.linkedin-post::before {\n  content: '';\n  position: absolute;\n  top: 0; left: 0; right: 0;\n  height: 3px;\n  background: linear-gradient(90deg, var(--brand), var(--brand-light), var(--accent));\n  transform: scaleX(0);\n  transform-origin: left;\n  transition: transform 0.3s var(--ease);\n  z-index: 1;\n}\n\n.linkedin-post:hover::before { transform: scaleX(1); }\n.linkedin-post:hover {\n  transform: translateY(-3px);\n  box-shadow: var(--shadow-md);\n}\n\n/* ======================================\n   POST HEADER\n====================================== */\n.post-header {\n  display: flex;\n  align-items: center;\n  padding: 16px 18px 12px;\n  gap: 10px;\n  border-bottom: 1px solid var(--border);\n}\n\n.post-user {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  cursor: pointer;\n  padding: 4px 8px 4px 4px;\n  border-radius: 100px;\n  background: transparent;\n  border: none;\n  transition: background 0.18s;\n  flex: 1;\n  min-width: 0;\n}\n\n.post-user:hover { background: var(--surface-3); }\n\n.post-profile-img {\n  width: 44px;\n  height: 44px;\n  border-radius: 50%;\n  object-fit: cover;\n  border: 2px solid var(--brand-soft);\n  box-shadow: 0 0 0 2px var(--border-strong);\n  flex-shrink: 0;\n}\n\n.post-user-info {\n  display: flex;\n  flex-direction: column;\n  min-width: 0;\n}\n\n.post-username {\n  font-family: var(--font);\n  font-weight: 700;\n  font-size: 14.5px;\n  color: var(--text-primary);\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n\n.post-user-info span:last-child,\n.post-user-info p {\n  font-size: 12px;\n  color: var(--text-muted);\n  margin: 0;\n}\n\n/* Follow button */\n.follow-btn-home {\n  margin-left: auto;\n  flex-shrink: 0;\n  padding: 7px 18px;\n  border-radius: 100px;\n  background: transparent;\n  color: var(--brand);\n  font-family: var(--font);\n  font-weight: 700;\n  font-size: 13px;\n  cursor: pointer;\n  border: 1.5px solid var(--brand);\n  transition: all 0.2s var(--ease);\n  white-space: nowrap;\n}\n\n.follow-btn-home:hover {\n  background: var(--brand);\n  color: white;\n  box-shadow: 0 3px 12px var(--brand-glow);\n}\n\n.follow-btn-home:disabled {\n  opacity: 0.5;\n  cursor: not-allowed;\n  transform: none;\n}\n\n/* More options button */\n.more-options-container {\n  position: relative;\n  flex-shrink: 0;\n}\n\n.more-btn {\n  width: 34px;\n  height: 34px;\n  background: none;\n  border: none;\n  color: var(--text-muted);\n  font-size: 18px;\n  cursor: pointer;\n  border-radius: 50%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  transition: all 0.18s;\n}\n\n.more-btn:hover {\n  background: var(--surface-3);\n  color: var(--brand);\n}\n\n/* Dropdown */\n.dropdown-content,\n.dropdown-options {\n  position: absolute;\n  top: 38px;\n  right: 0;\n  background: var(--surface);\n  border: 1px solid var(--border-strong);\n  border-radius: var(--radius-md);\n  box-shadow: var(--shadow-md);\n  z-index: 100;\n  width: 185px;\n  overflow: hidden;\n  animation: dropIn 0.18s var(--ease);\n}\n\n@keyframes dropIn {\n  from { opacity: 0; transform: translateY(-6px) scale(0.97); }\n  to   { opacity: 1; transform: translateY(0) scale(1); }\n}\n\n.dropdown-item {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  width: 100%;\n  padding: 10px 14px;\n  background: none;\n  border: none;\n  font-family: var(--font);\n  font-size: 13px;\n  font-weight: 500;\n  color: var(--text-secondary);\n  cursor: pointer;\n  text-align: left;\n  transition: background 0.14s;\n}\n\n.dropdown-item:hover {\n  background: var(--surface-3);\n  color: var(--brand);\n}\n\n/* ======================================\n   POST CONTENT & MEDIA\n====================================== */\n.post-content {\n  padding: 14px 18px 10px;\n}\n\n.post-text {\n  font-family: var(--font-serif);\n  font-size: 14.5px;\n  line-height: 1.72;\n  color: var(--text-secondary);\n  margin-bottom: 10px;\n  word-wrap: break-word;\n}\n\n.post-image {\n  width: 100%;\n  max-height: 520px;\n  object-fit: contain;\n  border-radius: 0;\n  margin-top: 8px;\n  background: var(--surface-2);\n  display: block;\n}\n\n.post-video {\n  width: 100%;\n  max-height: 480px;\n  display: block;\n  margin-top: 8px;\n}\n\n/* ======================================\n   POST STATS\n====================================== */\n.post-stats {\n  display: flex;\n  gap: 14px;\n  font-family: var(--font);\n  font-size: 12px;\n  color: var(--text-muted);\n  padding: 8px 18px;\n  border-bottom: 1px solid var(--border);\n}\n\n/* ======================================\n   POST ACTIONS (Like / Comment bar)\n====================================== */\n.post-actions {\n  display: flex;\n  gap: 4px;\n  padding: 8px 14px;\n  border-top: 1px solid var(--border);\n}\n\n.action-btn,\n.action-btn-home {\n  display: inline-flex;\n  align-items: center;\n  gap: 6px;\n  padding: 7px 14px;\n  border: none;\n  background: transparent;\n  color: var(--text-muted);\n  border-radius: 100px;\n  font-family: var(--font);\n  font-size: 13px;\n  font-weight: 600;\n  cursor: pointer;\n  transition: all 0.18s var(--ease);\n}\n\n.action-btn:hover,\n.action-btn-home:hover {\n  background: var(--brand-soft);\n  color: var(--brand);\n}\n\n.action-btn.liked,\n.action-btn-home.liked {\n  color: var(--like-red);\n  background: var(--like-soft);\n}\n\n.action-btn svg,\n.action-btn-home svg { font-size: 16px; }\n\n/* ======================================\n   HIGHLIGHT STATES\n====================================== */\n.highlight-post {\n  outline: 2px solid var(--brand-light);\n  background: var(--brand-soft);\n  transition: background 0.3s;\n}\n\n.highlight-comment {\n  background: var(--brand-soft);\n  border-left: 3px solid var(--brand);\n  padding-left: 8px;\n  border-radius: 0 var(--radius-sm) var(--radius-sm) 0;\n}\n\n/* ======================================\n   COMMENTS SECTION\n====================================== */\n.comments-section {\n  background: linear-gradient(135deg, var(--surface-2) 0%, var(--surface) 100%);\n  border-top: 3px solid;\n  border-image: linear-gradient(90deg, var(--brand), var(--accent)) 1;\n  padding: 28px 24px 24px;\n  border-radius: 0 0 var(--radius-lg) var(--radius-lg);\n  animation: slideDown 0.4s var(--ease);\n  box-shadow: \n    inset 0 2px 12px rgba(21, 101, 192, 0.06),\n    inset 0 -1px 3px rgba(255, 255, 255, 0.8);\n  position: relative;\n  overflow: hidden;\n}\n\n.comments-section::before {\n  content: '';\n  position: absolute;\n  top: 0;\n  left: 0;\n  right: 0;\n  height: 1px;\n  background: linear-gradient(90deg, transparent, var(--brand-light), transparent);\n  opacity: 0.5;\n}\n\n@keyframes slideDown {\n  from { opacity: 0; transform: translateY(-8px); }\n  to   { opacity: 1; transform: translateY(0); }\n}\n\n@keyframes slideIn {\n  from { opacity: 0; transform: translateX(-8px); }\n  to { opacity: 1; transform: translateX(0); }\n}\n\n@keyframes float {\n  0%, 100% { transform: translateY(0px); }\n  50% { transform: translateY(-10px); }\n}\n\n@keyframes pulse {\n  0%, 100% { opacity: 0.65; }\n  50% { opacity: 1; }\n}\n\n@keyframes cardIn {\n  from { opacity: 0; transform: translateY(10px); }\n  to   { opacity: 1; transform: translateY(0); }\n}\n\n.comments-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  margin-bottom: 24px;\n  padding: 0 0 16px 0;\n  border-bottom: 2px solid var(--border);\n  position: relative;\n  gap: 12px;\n}\n\n.comments-header::before {\n  content: '';\n  position: absolute;\n  bottom: -2px;\n  left: 0;\n  width: 80px;\n  height: 3px;\n  background: linear-gradient(90deg, var(--brand-light), var(--accent), var(--brand));\n  border-radius: 2px;\n  box-shadow: 0 0 12px rgba(21, 101, 192, 0.3);\n  animation: expandWidth 0.6s var(--ease);\n}\n\n@keyframes expandWidth {\n  from { width: 0; }\n  to { width: 80px; }\n}\n\n.comments-header h4 {\n  font-family: var(--font);\n  font-size: 15px;\n  font-weight: 700;\n  color: var(--text-primary);\n  text-transform: none;\n  letter-spacing: -0.3px;\n  margin: 0;\n  display: flex;\n  align-items: center;\n  gap: 8px;\n}\n\n.comments-header h4::before {\n  content: '💬';\n  font-size: 16px;\n}\n\n.close-comments-btn {\n  width: 40px;\n  height: 40px;\n  background: none;\n  border: none;\n  color: var(--text-muted);\n  cursor: pointer;\n  border-radius: 50%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-size: 19px;\n  transition: all 0.3s cubic-bezier(0.34, 1.56, 0.64, 1);\n  flex-shrink: 0;\n  position: relative;\n  box-shadow: inset 0 0 0 2px transparent;\n}\n\n.close-comments-btn::before {\n  content: '';\n  position: absolute;\n  inset: -4px;\n  background: radial-gradient(circle, var(--danger-soft) 0%, transparent 70%);\n  opacity: 0;\n  transition: opacity 0.3s ease;\n  border-radius: 50%;\n  pointer-events: none;\n}\n\n.close-comments-btn:hover {\n  background: linear-gradient(135deg, var(--danger-soft), rgba(239, 68, 68, 0.08));\n  color: var(--danger);\n  transform: scale(1.15) rotate(90deg);\n  box-shadow: 0 4px 12px rgba(239, 68, 68, 0.2);\n}\n\n.close-comments-btn:hover::before {\n  opacity: 0.5;\n}\n\n/* ======================================\n   LOADING SKELETON\n====================================== */\n.comment-loading-skeleton {\n  display: flex;\n  gap: 12px;\n  padding: 16px;\n  animation: shimmer 2s ease-in-out infinite;\n  background: linear-gradient(\n    90deg,\n    var(--border) 0%,\n    var(--border-strong) 20%,\n    var(--border) 40%,\n    var(--border) 100%\n  );\n  background-size: 200% 100%;\n  border-radius: var(--radius-md);\n  border: 1.5px solid var(--border);\n}\n\n@keyframes shimmer {\n  0% { background-position: 200% 0; }\n  100% { background-position: -200% 0; }\n}\n\n.skeleton-avatar {\n  width: 42px;\n  height: 42px;\n  border-radius: 50%;\n  background: linear-gradient(90deg, var(--border-strong), var(--border));\n  flex-shrink: 0;\n  animation: pulse 1.8s ease-in-out infinite;\n}\n\n.skeleton-content {\n  flex: 1;\n  display: flex;\n  flex-direction: column;\n  gap: 10px;\n}\n\n.skeleton-line {\n  height: 13px;\n  background: linear-gradient(90deg, var(--border-strong), var(--border));\n  border-radius: 7px;\n  animation: pulse 1.8s ease-in-out infinite;\n}\n\n.skeleton-line.short {\n  width: 55%;\n}\n\n/* ======================================\n   EMPTY STATE\n====================================== */\n.comments-empty-state {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  padding: 48px 24px;\n  text-align: center;\n  color: var(--text-muted);\n  background: linear-gradient(135deg, rgba(227, 242, 253, 0.3), rgba(211, 235, 248, 0.2));\n  border-radius: var(--radius-md);\n  border: 2.5px dashed var(--border-strong);\n  animation: fadeInScale 0.4s var(--ease);\n}\n\n@keyframes fadeInScale {\n  from { opacity: 0; transform: scale(0.95) translateY(8px); }\n  to { opacity: 1; transform: scale(1) translateY(0); }\n}\n\n.empty-icon {\n  font-size: 48px;\n  margin-bottom: 14px;\n  animation: float 3.5s ease-in-out infinite;\n}\n\n.comments-empty-state p {\n  font-family: var(--font);\n  font-size: 16px;\n  font-weight: 700;\n  margin: 0 0 8px 0;\n  color: var(--text-secondary);\n  letter-spacing: -0.3px;\n}\n\n.comments-empty-state span {\n  font-family: var(--font);\n  font-size: 13.5px;\n  color: var(--text-muted);\n  line-height: 1.6;\n  font-weight: 500;\n}\n\n/* ======================================\n   COMMENT CARDS\n====================================== */\n.comments-list {\n  max-height: 450px;\n  overflow-y: auto;\n  margin-bottom: 28px;\n  display: flex;\n  flex-direction: column;\n  gap: 14px;\n  padding-right: 8px;\n  position: relative;\n}\n\n.comments-list::before {\n  content: '';\n  position: sticky;\n  top: 0;\n  height: 0;\n  background: linear-gradient(to bottom, var(--surface-2), transparent);\n  pointer-events: none;\n  z-index: 5;\n}\n\n.comments-list::-webkit-scrollbar {\n  width: 8px;\n}\n\n.comments-list::-webkit-scrollbar-track {\n  background: transparent;\n  border-radius: 4px;\n}\n\n.comments-list::-webkit-scrollbar-thumb {\n  background: linear-gradient(to bottom, var(--brand-light), var(--brand));\n  border-radius: 4px;\n  transition: all 0.3s ease;\n  box-shadow: 0 0 8px rgba(21, 101, 192, 0.2);\n}\n\n.comments-list::-webkit-scrollbar-thumb:hover {\n  background: linear-gradient(to bottom, var(--brand-mid), var(--brand-light));\n  box-shadow: 0 0 12px rgba(21, 101, 192, 0.35);\n}\n\n.comment-card {\n  display: flex;\n  flex-direction: column;\n  gap: 12px;\n  padding: 16px 18px;\n  background: linear-gradient(135deg, rgba(255, 255, 255, 0.9), rgba(248, 250, 252, 0.8));\n  border: 2px solid var(--border);\n  border-radius: var(--radius-md);\n  transition: all 0.35s cubic-bezier(0.34, 1.56, 0.64, 1);\n  position: relative;\n  overflow: hidden;\n  backdrop-filter: blur(8px);\n}\n\n.comment-card::before {\n  content: '';\n  position: absolute;\n  left: 0;\n  top: 0;\n  height: 100%;\n  width: 4px;\n  background: linear-gradient(to bottom, var(--brand), var(--brand-light), var(--accent));\n  opacity: 0;\n  transition: opacity 0.35s ease;\n  box-shadow: 0 0 12px rgba(21, 101, 192, 0.3);\n}\n\n.comment-card::after {\n  content: '';\n  position: absolute;\n  inset: 0;\n  background: radial-gradient(circle at var(--mouse-x, 50%) var(--mouse-y, 50%), rgba(21, 101, 192, 0.05), transparent);\n  opacity: 0;\n  transition: opacity 0.3s ease;\n  pointer-events: none;\n}\n\n.comment-card:hover {\n  border-color: var(--brand-light);\n  box-shadow: \n    0 8px 24px rgba(21, 101, 192, 0.16),\n    inset 0 1px 0 rgba(255, 255, 255, 0.6);\n  background: linear-gradient(135deg, rgba(227, 242, 253, 0.9), rgba(248, 250, 252, 0.95));\n  transform: translateY(-4px) scale(1.01);\n}\n\n.comment-card:hover::before {\n  opacity: 1;\n}\n\n.comment-card:hover::after {\n  opacity: 1;\n}\n\n.comment-main {\n  display: flex;\n  gap: 12px;\n  align-items: flex-start;\n  position: relative;\n}\n\n.comment-avatar,\n.reply-avatar {\n  width: 40px;\n  height: 40px;\n  border-radius: 50%;\n  object-fit: cover;\n  border: 3px solid var(--brand-soft);\n  flex-shrink: 0;\n  transition: all 0.35s cubic-bezier(0.34, 1.56, 0.64, 1);\n  box-shadow: \n    0 4px 16px rgba(21, 101, 192, 0.2),\n    inset 0 -2px 4px rgba(0, 0, 0, 0.1);\n  position: relative;\n}\n\n.comment-avatar::after {\n  content: '';\n  position: absolute;\n  inset: 0;\n  border-radius: 50%;\n  background: radial-gradient(circle at 30% 30%, rgba(255, 255, 255, 0.4), transparent);\n  opacity: 0;\n  transition: opacity 0.3s ease;\n}\n\n.comment-card:hover .comment-avatar,\n.comment-card:hover .reply-avatar {\n  border-color: var(--brand-light);\n  box-shadow: \n    0 6px 20px rgba(21, 101, 192, 0.35),\n    inset 0 -2px 4px rgba(0, 0, 0, 0.1);\n  transform: scale(1.12) rotate(3deg);\n}\n\n.comment-card:hover .comment-avatar::after {\n  opacity: 1;\n}\n\n.comment-content,\n.reply-content {\n  flex: 1;\n  min-width: 0;\n}\n\n.comment-bubble,\n.reply-bubble {\n  background: linear-gradient(135deg, rgba(238, 244, 251, 0.8), rgba(227, 242, 253, 0.6));\n  border: 2px solid var(--border-strong);\n  border-radius: 18px;\n  padding: 14px 18px;\n  position: relative;\n  margin-bottom: 8px;\n  box-shadow: \n    0 4px 12px rgba(21, 101, 192, 0.08),\n    inset 0 1px 0 rgba(255, 255, 255, 0.8);\n  transition: all 0.3s ease;\n  backdrop-filter: blur(10px);\n}\n\n.comment-card:hover .comment-bubble {\n  background: linear-gradient(135deg, rgba(227, 242, 253, 0.9), rgba(211, 235, 248, 0.7));\n  border-color: var(--brand-light);\n  box-shadow: \n    0 6px 20px rgba(21, 101, 192, 0.14),\n    inset 0 1px 0 rgba(255, 255, 255, 0.9);\n}\n\n.comment-bubble::before,\n.reply-bubble::before {\n  content: '';\n  position: absolute;\n  top: 12px;\n  left: -7px;\n  width: 0;\n  height: 0;\n  border: 8px solid transparent;\n  border-right-color: var(--border-strong);\n  border-left: 0;\n}\n\n.comment-bubble::after,\n.reply-bubble::after {\n  content: '';\n  position: absolute;\n  top: 13px;\n  left: -5px;\n  width: 0;\n  height: 0;\n  border: 7px solid transparent;\n  border-right-color: var(--surface-3);\n  border-left: 0;\n}\n\n.comment-header-info,\n.reply-header-info {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  margin-bottom: 6px;\n  flex-wrap: wrap;\n}\n\n.comment-author,\n.reply-author {\n  font-family: var(--font);\n  font-size: 13.5px;\n  font-weight: 700;\n  color: var(--text-primary);\n  letter-spacing: -0.2px;\n}\n\n.comment-time,\n.reply-time {\n  font-family: var(--font);\n  font-size: 11px;\n  color: var(--text-muted);\n  font-weight: 500;\n  opacity: 0.8;\n  transition: opacity 0.2s ease;\n}\n\n.comment-card:hover .comment-time {\n  opacity: 1;\n  color: var(--brand-light);\n}\n\n.comment-text,\n.reply-text {\n  font-family: var(--font);\n  font-size: 14px;\n  color: var(--text-secondary);\n  line-height: 1.55;\n  margin: 0;\n  word-wrap: break-word;\n  letter-spacing: -0.1px;\n}\n\n.comment-footer {\n  display: flex;\n  gap: 16px;\n  margin-left: 16px;\n  margin-top: 8px;\n}\n\n.comment-action-btn {\n  background: none;\n  border: none;\n  font-family: var(--font);\n  font-size: 12px;\n  font-weight: 700;\n  color: var(--text-muted);\n  cursor: pointer;\n  padding: 8px 14px;\n  border-radius: 10px;\n  transition: all 0.25s cubic-bezier(0.34, 1.56, 0.64, 1);\n  letter-spacing: -0.3px;\n  position: relative;\n  overflow: hidden;\n  display: inline-flex;\n  align-items: center;\n  gap: 4px;\n}\n\n.comment-action-btn::before {\n  content: '';\n  position: absolute;\n  inset: 0;\n  background: linear-gradient(135deg, var(--brand-soft), transparent);\n  opacity: 0;\n  transition: opacity 0.25s ease;\n  pointer-events: none;\n  z-index: -1;\n}\n\n.comment-action-btn::after {\n  content: '';\n  position: absolute;\n  bottom: 0;\n  left: 50%;\n  width: 0;\n  height: 2px;\n  background: linear-gradient(90deg, var(--brand), var(--accent));\n  transform: translateX(-50%);\n  transition: width 0.25s ease;\n}\n\n.comment-action-btn:hover {\n  color: var(--brand);\n  background: var(--brand-soft);\n  transform: translateY(-3px) scale(1.05);\n  box-shadow: 0 4px 12px rgba(21, 101, 192, 0.15);\n}\n\n.comment-action-btn:hover::after {\n  width: 80%;\n}\n\n.view-replies-btn:hover {\n  color: var(--brand-mid);\n  background: rgba(25, 118, 210, 0.1);\n}\n\n.comment-menu-btn,\n.reply-menu-btn {\n  background: none;\n  border: none;\n  color: var(--text-muted);\n  cursor: pointer;\n  width: 40px;\n  height: 40px;\n  border-radius: 50%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  flex-shrink: 0;\n  font-size: 20px;\n  font-weight: bold;\n  transition: all 0.3s cubic-bezier(0.34, 1.56, 0.64, 1);\n  margin-left: auto;\n  opacity: 0.4;\n  transform: scale(0.85);\n  box-shadow: inset 0 0 0 1px transparent;\n}\n\n.comment-card:hover .comment-menu-btn,\n.reply-card:hover .reply-menu-btn {\n  opacity: 1;\n  transform: scale(1);\n}\n\n.comment-menu-btn:hover,\n.reply-menu-btn:hover {\n  background: linear-gradient(135deg, var(--danger-soft), rgba(239, 68, 68, 0.08));\n  color: var(--danger);\n  transform: scale(1.2) rotate(90deg);\n  box-shadow: 0 4px 12px rgba(239, 68, 68, 0.2);\n}\n\n/* ======================================\n   REPLIES\n====================================== */\n.replies-container {\n  margin-left: 52px;\n  display: flex;\n  flex-direction: column;\n  gap: 12px;\n  padding-left: 20px;\n  border-left: 4px solid;\n  border-image: linear-gradient(to bottom, var(--brand-light), var(--brand-soft)) 1;\n  animation: slideIn 0.3s var(--ease);\n  position: relative;\n}\n\n.replies-container::before {\n  content: '';\n  position: absolute;\n  left: -4px;\n  top: 0;\n  height: 100%;\n  width: 4px;\n  background: linear-gradient(to bottom, var(--brand-mid), var(--brand-soft), transparent);\n  opacity: 0;\n  transition: opacity 0.3s ease;\n}\n\n.reply-card {\n  display: flex;\n  gap: 10px;\n  align-items: flex-start;\n  padding: 14px 16px;\n  background: linear-gradient(135deg, rgba(238, 244, 251, 0.7), rgba(248, 250, 252, 0.8));\n  border-radius: var(--radius-md);\n  border: 2px solid var(--border-strong);\n  transition: all 0.3s cubic-bezier(0.34, 1.56, 0.64, 1);\n  position: relative;\n  backdrop-filter: blur(8px);\n}\n\n.reply-card::before {\n  content: '';\n  position: absolute;\n  left: 0;\n  top: 0;\n  height: 100%;\n  width: 3px;\n  background: linear-gradient(to bottom, var(--brand-mid), var(--brand-soft));\n  opacity: 0;\n  transition: opacity 0.3s ease;\n  border-radius: var(--radius-md) 0 0 var(--radius-md);\n}\n\n.reply-card:hover {\n  background: linear-gradient(135deg, rgba(227, 242, 253, 0.85), rgba(211, 235, 248, 0.85));\n  border-color: var(--brand-light);\n  box-shadow: 0 6px 20px rgba(21, 101, 192, 0.14);\n  transform: translateX(3px) translateY(-2px);\n}\n\n.reply-card:hover::before {\n  opacity: 1;\n}\n\n.reply-avatar {\n  width: 32px;\n  height: 32px;\n  border: 2px solid var(--brand-light);\n}\n\n.reply-bubble {\n  background: linear-gradient(135deg, var(--surface), var(--surface-2));\n  padding: 10px 14px;\n  border: 1px solid var(--border);\n  box-shadow: 0 1px 4px rgba(21, 101, 192, 0.05);\n}\n\n.reply-bubble::before,\n.reply-bubble::after {\n  display: none;\n}\n\n.reply-author {\n  font-size: 12.5px;\n  font-weight: 700;\n}\n\n.reply-time {\n  font-size: 10.5px;\n}\n\n.reply-text {\n  font-size: 13.5px;\n  color: var(--text-secondary);\n}\n\n/* ======================================\n   REPLY INPUT WRAPPER\n====================================== */\n.reply-input-wrapper {\n  margin-left: 52px;\n  margin-top: 8px;\n  animation: fadeIn 0.2s ease;\n}\n\n@keyframes fadeIn {\n  from { opacity: 0; transform: translateY(-4px); }\n  to { opacity: 1; transform: translateY(0); }\n}\n\n/* ======================================\n   COMMENT INPUT SECTION\n====================================== */\n.comment-input-section {\n  border-top: 2px solid var(--border);\n  padding-top: 18px;\n  margin-top: 6px;\n}\n\n/* ======================================\n   COMMENT INPUT\n====================================== */\n.comment-input-container {\n  display: flex;\n  align-items: flex-start;\n  gap: 12px;\n}\n\n.comment-input-wrapper {\n  flex: 1;\n  display: flex;\n  flex-direction: column;\n  gap: 10px;\n  position: relative;\n  min-width: 0;\n}\n\n.comment-user-img {\n  width: 40px;\n  height: 40px;\n  border-radius: 50%;\n  object-fit: cover;\n  border: 2px solid var(--brand-soft);\n  flex-shrink: 0;\n  box-shadow: 0 2px 6px rgba(21, 101, 192, 0.15);\n}\n\n.comment-input {\n  width: 100%;\n  padding: 13px 115px 13px 20px;\n  border: 2.5px solid var(--border);\n  border-radius: 28px;\n  font-family: var(--font);\n  font-size: 14px;\n  color: var(--text-primary);\n  background: linear-gradient(135deg, rgba(248, 250, 252, 0.8), rgba(227, 242, 253, 0.5));\n  outline: none;\n  transition: all 0.35s cubic-bezier(0.34, 1.56, 0.64, 1);\n  box-sizing: border-box;\n  resize: none;\n  letter-spacing: -0.2px;\n  box-shadow: 0 2px 8px rgba(21, 101, 192, 0.06);\n}\n\n.comment-input::placeholder {\n  color: var(--text-muted);\n  font-weight: 500;\n}\n\n.comment-input:focus {\n  border-color: var(--brand-mid);\n  box-shadow: \n    0 0 0 5px var(--brand-soft),\n    0 4px 16px rgba(21, 101, 192, 0.15);\n  transform: translateY(-3px) scale(1.01);\n  background: linear-gradient(135deg, rgba(227, 242, 253, 0.9), rgba(211, 235, 248, 0.7));\n}\n\n.comment-input-actions {\n  position: absolute;\n  right: 12px;\n  top: 50%;\n  transform: translateY(-50%);\n  display: flex;\n  align-items: center;\n  gap: 8px;\n}\n\n.emoji-btn {\n  width: 38px;\n  height: 38px;\n  background: none;\n  border: none;\n  color: var(--text-muted);\n  cursor: pointer;\n  font-size: 20px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  border-radius: 50%;\n  transition: all 0.3s cubic-bezier(0.34, 1.56, 0.64, 1);\n  flex-shrink: 0;\n  position: relative;\n  box-shadow: inset 0 0 0 2px transparent;\n}\n\n.emoji-btn::before {\n  content: '';\n  position: absolute;\n  inset: -4px;\n  background: radial-gradient(circle, var(--brand-soft) 0%, transparent 70%);\n  opacity: 0;\n  transition: opacity 0.3s ease;\n  border-radius: 50%;\n  pointer-events: none;\n}\n\n.emoji-btn:hover {\n  background: var(--brand-soft);\n  color: var(--brand);\n  transform: scale(1.2) rotate(20deg);\n  box-shadow: 0 4px 12px rgba(21, 101, 192, 0.2);\n}\n\n.emoji-btn:hover::before {\n  opacity: 0.5;\n}\n\n.post-comment-btn {\n  padding: 9px 20px;\n  background: linear-gradient(135deg, var(--brand), var(--brand-mid), var(--brand-light));\n  color: white;\n  border: none;\n  border-radius: 22px;\n  font-family: var(--font);\n  font-size: 13px;\n  font-weight: 700;\n  cursor: pointer;\n  box-shadow: \n    0 4px 16px var(--brand-glow),\n    inset 0 -2px 4px rgba(0, 0, 0, 0.1),\n    inset 0 1px 2px rgba(255, 255, 255, 0.3);\n  transition: all 0.3s cubic-bezier(0.34, 1.56, 0.64, 1);\n  white-space: nowrap;\n  letter-spacing: -0.3px;\n  flex-shrink: 0;\n  position: relative;\n  overflow: hidden;\n  text-shadow: 0 1px 2px rgba(0, 0, 0, 0.1);\n}\n\n.post-comment-btn::before {\n  content: '';\n  position: absolute;\n  inset: 0;\n  background: radial-gradient(circle at 30% 30%, rgba(255, 255, 255, 0.4), transparent 70%);\n  opacity: 0;\n  transition: opacity 0.3s ease;\n  pointer-events: none;\n}\n\n.post-comment-btn::after {\n  content: '';\n  position: absolute;\n  inset: 0;\n  background: linear-gradient(135deg, transparent, rgba(255, 255, 255, 0.2), transparent);\n  opacity: 0;\n  transition: opacity 0.3s ease;\n  pointer-events: none;\n}\n\n.post-comment-btn:hover:not(:disabled) {\n  transform: translateY(-4px) scale(1.05);\n  box-shadow: \n    0 10px 28px var(--brand-glow),\n    inset 0 -2px 4px rgba(0, 0, 0, 0.15),\n    inset 0 1px 2px rgba(255, 255, 255, 0.4);\n}\n\n.post-comment-btn:hover:not(:disabled)::before {\n  opacity: 1;\n}\n\n.post-comment-btn:hover:not(:disabled)::after {\n  opacity: 1;\n}\n\n.post-comment-btn:disabled {\n  opacity: 0.35;\n  cursor: not-allowed;\n  transform: none;\n  background: linear-gradient(135deg, var(--text-muted), var(--text-muted));\n  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.1);\n}\n\n/* ======================================\n   REPLY INPUT\n====================================== */\n.reply-input-container {\n  position: relative;\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  padding: 16px 18px;\n  background: linear-gradient(135deg, rgba(238, 244, 251, 0.8), rgba(227, 242, 253, 0.6));\n  border-radius: var(--radius-md);\n  border: 2.5px solid var(--border-strong);\n  box-shadow: \n    0 4px 16px rgba(21, 101, 192, 0.1),\n    inset 0 1px 0 rgba(255, 255, 255, 0.8);\n  transition: all 0.35s cubic-bezier(0.34, 1.56, 0.64, 1);\n  backdrop-filter: blur(10px);\n}\n\n.reply-input-container:focus-within {\n  border-color: var(--brand-mid);\n  box-shadow: \n    0 8px 24px rgba(21, 101, 192, 0.16),\n    inset 0 1px 0 rgba(255, 255, 255, 0.9);\n  background: linear-gradient(135deg, rgba(227, 242, 253, 0.9), rgba(211, 235, 248, 0.7));\n}\n\n.reply-input {\n  flex: 1;\n  padding: 11px 16px;\n  border: 2.5px solid var(--border);\n  border-radius: 22px;\n  font-family: var(--font);\n  font-size: 13px;\n  color: var(--text-primary);\n  background: linear-gradient(135deg, rgba(248, 250, 252, 0.85), rgba(227, 242, 253, 0.5));\n  outline: none;\n  transition: all 0.3s cubic-bezier(0.34, 1.56, 0.64, 1);\n  min-width: 0;\n  letter-spacing: -0.2px;\n  box-shadow: 0 2px 6px rgba(21, 101, 192, 0.04);\n}\n\n.reply-input::placeholder {\n  color: var(--text-muted);\n  font-weight: 500;\n}\n\n.reply-input:focus {\n  border-color: var(--brand-mid);\n  box-shadow: \n    0 0 0 4px var(--brand-soft),\n    0 4px 14px rgba(21, 101, 192, 0.12);\n  transform: translateY(-2px) scale(1.01);\n  background: linear-gradient(135deg, rgba(227, 242, 253, 0.9), rgba(211, 235, 248, 0.6));\n}\n\n.reply-input-actions {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  flex-shrink: 0;\n}\n\n.send-reply-btn {\n  width: 40px;\n  height: 40px;\n  background: linear-gradient(135deg, var(--brand), var(--brand-mid), var(--brand-light));\n  color: white;\n  border: none;\n  border-radius: 50%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-size: 17px;\n  cursor: pointer;\n  box-shadow: \n    0 4px 16px var(--brand-glow),\n    inset 0 -2px 4px rgba(0, 0, 0, 0.1),\n    inset 0 1px 2px rgba(255, 255, 255, 0.3);\n  transition: all 0.3s cubic-bezier(0.34, 1.56, 0.64, 1);\n  flex-shrink: 0;\n  position: relative;\n  overflow: hidden;\n}\n\n.send-reply-btn::before {\n  content: '';\n  position: absolute;\n  inset: 0;\n  background: radial-gradient(circle, rgba(255, 255, 255, 0.3), transparent 70%);\n  opacity: 0;\n  transition: opacity 0.3s ease;\n  pointer-events: none;\n  border-radius: 50%;\n}\n\n.send-reply-btn:hover:not(:disabled) {\n  transform: scale(1.2) translateY(-3px);\n  box-shadow: \n    0 8px 24px var(--brand-glow),\n    inset 0 -2px 4px rgba(0, 0, 0, 0.15),\n    inset 0 1px 2px rgba(255, 255, 255, 0.4);\n}\n\n.send-reply-btn:hover:not(:disabled)::before {\n  opacity: 1;\n}\n\n.send-reply-btn:disabled {\n  opacity: 0.35;\n  cursor: not-allowed;\n  transform: none;\n  background: linear-gradient(135deg, var(--text-muted), var(--text-muted));\n  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.1);\n}\n\n.close-reply-btn {\n  width: 40px;\n  height: 40px;\n  background: none;\n  border: none;\n  color: var(--text-muted);\n  cursor: pointer;\n  border-radius: 50%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-size: 17px;\n  transition: all 0.3s cubic-bezier(0.34, 1.56, 0.64, 1);\n  flex-shrink: 0;\n  position: relative;\n  box-shadow: inset 0 0 0 2px transparent;\n}\n\n.close-reply-btn::before {\n  content: '';\n  position: absolute;\n  inset: -4px;\n  background: radial-gradient(circle, var(--danger-soft) 0%, transparent 70%);\n  opacity: 0;\n  transition: opacity 0.3s ease;\n  border-radius: 50%;\n  pointer-events: none;\n}\n\n.close-reply-btn:hover {\n  background: linear-gradient(135deg, var(--danger-soft), rgba(239, 68, 68, 0.08));\n  color: var(--danger);\n  transform: scale(1.15) rotate(90deg);\n  box-shadow: 0 4px 12px rgba(239, 68, 68, 0.2);\n}\n\n.close-reply-btn:hover::before {\n  opacity: 0.5;\n}\n\n/* ======================================\n   EMOJI PICKER\n====================================== */\n.emoji-picker-wrapper {\n  position: absolute;\n  bottom: calc(100% + 10px);\n  right: 0;\n  z-index: 1000;\n  background: var(--surface);\n  border: 2.5px solid var(--border-strong);\n  border-radius: var(--radius-md);\n  box-shadow: \n    0 12px 32px rgba(21, 101, 192, 0.2),\n    inset 0 1px 0 rgba(255, 255, 255, 0.9);\n  overflow: hidden;\n  animation: popIn 0.3s cubic-bezier(0.34, 1.56, 0.64, 1);\n  backdrop-filter: blur(12px);\n}\n\n@keyframes popIn {\n  from { opacity: 0; transform: scale(0.85) translateY(12px); }\n  to { opacity: 1; transform: scale(1) translateY(0); }\n}\n\n.reply-input-container .emoji-picker-wrapper {\n  bottom: calc(100% + 10px);\n}\n\n.EmojiPickerReact {\n  max-width: 320px !important;\n  height: 380px !important;\n  --emoji-picker-category-label-bg-color: linear-gradient(90deg, var(--surface), var(--surface-3)) !important;\n  --emoji-picker-skin-tone-popup-background: var(--surface-3) !important;\n}\n\n.emoji-picker-header {\n  display: flex;\n  justify-content: flex-end;\n  padding: 8px 10px;\n  border-bottom: 2px solid var(--border);\n  background: linear-gradient(90deg, var(--surface), var(--surface-2));\n}\n\n.close-emoji-picker {\n  width: 32px;\n  height: 32px;\n  background: none;\n  border: none;\n  color: var(--text-muted);\n  cursor: pointer;\n  border-radius: 50%;\n  font-size: 15px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  transition: all 0.25s cubic-bezier(0.34, 1.56, 0.64, 1);\n  flex-shrink: 0;\n  position: relative;\n  box-shadow: inset 0 0 0 2px transparent;\n}\n\n.close-emoji-picker:hover {\n  background: linear-gradient(135deg, var(--danger-soft), rgba(239, 68, 68, 0.08));\n  color: var(--danger);\n  transform: scale(1.15) rotate(90deg);\n  box-shadow: 0 3px 10px rgba(239, 68, 68, 0.15);\n}\n\n/* ======================================\n   CONFIRMATION DIALOG\n====================================== */\n.confirmation-dialog-overlay {\n  position: fixed;\n  inset: 0;\n  background: rgba(13, 27, 42, 0.55);\n  backdrop-filter: blur(6px);\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  z-index: 1000;\n}\n\n.confirmation-dialog {\n  background: var(--surface);\n  padding: 28px 32px;\n  border-radius: var(--radius-lg);\n  width: 92%;\n  max-width: 380px;\n  box-shadow: var(--shadow-lg);\n  border: 1px solid var(--border-strong);\n  text-align: center;\n  animation: modalIn 0.25s var(--ease);\n  position: relative;\n  overflow: hidden;\n}\n\n.confirmation-dialog::before {\n  content: '';\n  display: block;\n  height: 4px;\n  background: linear-gradient(90deg, var(--danger), #FF8A80);\n  position: absolute;\n  top: 0; left: 0; right: 0;\n}\n\n@keyframes modalIn {\n  from { opacity: 0; transform: scale(0.95) translateY(12px); }\n  to   { opacity: 1; transform: scale(1) translateY(0); }\n}\n\n.confirmation-dialog h3 {\n  font-family: var(--font);\n  font-size: 17px;\n  font-weight: 800;\n  color: var(--text-primary);\n  margin: 10px 0 8px;\n}\n\n.confirmation-dialog p {\n  font-family: var(--font);\n  font-size: 13.5px;\n  color: var(--text-muted);\n  line-height: 1.6;\n  margin: 0 0 22px;\n}\n\n.confirmation-buttons {\n  display: flex;\n  justify-content: center;\n  gap: 10px;\n}\n\n.cancel-btn {\n  padding: 9px 22px;\n  background: var(--surface-2);\n  color: var(--text-secondary);\n  border: 1.5px solid var(--border-strong);\n  border-radius: 100px;\n  font-family: var(--font);\n  font-size: 13px;\n  font-weight: 600;\n  cursor: pointer;\n  min-width: 90px;\n  transition: all 0.18s var(--ease);\n}\n\n.cancel-btn:hover {\n  background: var(--border);\n  color: var(--text-primary);\n}\n\n.delete-btn-home-comment {\n  padding: 9px 22px;\n  background: var(--danger);\n  color: white;\n  border: none;\n  border-radius: 100px;\n  font-family: var(--font);\n  font-size: 13px;\n  font-weight: 700;\n  cursor: pointer;\n  min-width: 90px;\n  box-shadow: 0 2px 8px rgba(239,68,68,0.3);\n  transition: all 0.18s var(--ease);\n}\n\n.delete-btn-home-comment:hover {\n  background: #DC2626;\n  transform: translateY(-1px);\n  box-shadow: 0 4px 14px rgba(239,68,68,0.35);\n}\n\n/* Reply stats */\n.replies-summary { margin-left: 44px; margin-bottom: 4px; }\n\n.reply-stats {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  font-family: var(--font);\n  font-size: 11.5px;\n  color: var(--text-muted);\n}\n\n/* ======================================\n   RESPONSIVE\n====================================== */\n@media (max-width: 1024px) {\n  .linkedin-feed { max-width: 90%; padding: 16px; }\n  .post-profile-img { width: 40px; height: 40px; }\n  .comment-user-img, .reply-user-img { width: 32px; height: 32px; }\n}\n\n@media (max-width: 768px) {\n  .linkedin-feed { padding: 12px 10px; margin: 80px auto 0; max-width: 100%; }\n  .linkedin-post { border-radius: var(--radius-md); }\n  .post-header { padding: 12px 14px 10px; }\n  .post-content { padding: 12px 14px 8px; }\n  .post-profile-img { width: 38px; height: 38px; }\n  .comment-user-img, .reply-user-img { width: 30px; height: 30px; }\n  .comments-section { padding: 12px 14px; }\n  .reply-input-container { margin-left: 36px; }\n  .comment-actions { margin-left: 36px; }\n  .replies-list { margin-left: 36px; }\n}\n\n@media (max-width: 480px) {\n  .linkedin-feed { padding: 10px 8px; margin: 70px auto 0; }\n  .linkedin-post { border-radius: var(--radius-sm); margin-bottom: 12px; }\n  .post-header { padding: 10px 12px; }\n  .post-content { padding: 10px 12px; }\n  .comment-input { font-size: 13px; padding: 9px 80px 9px 14px; }\n  .reply-input { font-size: 12.5px; }\n  .post-comment-btn { font-size: 11.5px; padding: 5px 10px; }\n  .action-btn, .action-btn-home { padding: 6px 10px; font-size: 12px; }\n  .confirmation-dialog { padding: 22px 20px; }\n  .emoji-picker-wrapper { max-width: 92vw; right: 0; left: 0; margin: auto; }\n  .loading-container-home { height: 150px; }\n  .loading-spinner-home { width: 40px; height: 40px; }\n}\n\n@media (max-width: 375px) {\n  .comment-input, .reply-input { font-size: 12px; }\n  .post-comment-btn, .send-reply-btn { font-size: 11px; }\n  .linkedin-feed { padding: 8px 6px; }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
